import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
};

export type Activity = {
  __typename?: 'Activity';
  _id?: Maybe<Scalars['ID']['output']>;
  changes?: Maybe<Array<Maybe<ActivityChange>>>;
  createdBy?: Maybe<CreateData>;
  date?: Maybe<Scalars['Date']['output']>;
  entity?: Maybe<ActivityEntity>;
  /** @deprecated fields shouldn't be used, changes should now be used instead */
  fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parentId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ActivityType>;
};

export type ActivityChange = {
  __typename?: 'ActivityChange';
  key?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** @deprecated value shouldn't be used, newValue & oldValue should now be used */
  value?: Maybe<Scalars['String']['output']>;
};

export enum ActivityEntity {
  Booking = 'booking',
  Floor = 'floor',
  Location = 'location',
  Space = 'space',
  Visit = 'visit',
  Visitor = 'visitor'
}

export enum ActivityType {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

export type Allergen = {
  __typename?: 'Allergen';
  broader?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  notation?: Maybe<Scalars['String']['output']>;
  riskStatement?: Maybe<Scalars['String']['output']>;
};

export type AllowedDay = {
  __typename?: 'AllowedDay';
  day?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type Amenity = {
  __typename?: 'Amenity';
  _id?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AssignJobInput = {
  assignTo: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};

export type AssignedBy = {
  __typename?: 'AssignedBy';
  timestamp?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AssignedGroup = {
  __typename?: 'AssignedGroup';
  _id?: Maybe<Scalars['ID']['output']>;
  group?: Maybe<Group>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AssignedLayout = {
  __typename?: 'AssignedLayout';
  capacity?: Maybe<Scalars['Int']['output']>;
  jobItemId?: Maybe<Scalars['ID']['output']>;
  layout?: Maybe<SpaceAssignedLayout>;
  layoutId?: Maybe<Scalars['ID']['output']>;
  resetMinutes?: Maybe<Scalars['Int']['output']>;
  setupMinutes?: Maybe<Scalars['Int']['output']>;
};

export type AssistantResponse = {
  __typename?: 'AssistantResponse';
  _id?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  conversationName?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  role?: Maybe<ResponseType>;
};

export type AttendeeData = {
  __typename?: 'AttendeeData';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isVisitor?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
};

/** The available filters that can be used to filter the location availability query results */
export type AvailabilityFilters = {
  /** only returns spaces that have all of the listed amenities */
  amenities?: InputMaybe<Array<InputMaybe<InputAmenity>>>;
  /** only returns spaces that have capacity < maxCapacity */
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** only returns spaces that have capacity > minCapacity */
  minCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to only return Spaces that the user has permissions to book */
  onlyAllowedSpaces?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to only return favourites */
  onlyFavourites?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to return bookable desks. These are desks that the user can book */
  showBookable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return desks that have associated bookings */
  showBooked?: InputMaybe<Scalars['Boolean']['input']>;
  /** only return desks that are not bookable. (Set to not bookable within the admin area) */
  showNonBookable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The number of records to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** The limit of how many records to return */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** A partial object of user with all the information required to calculate the availability for the user */
export type AvailabilityUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type AvailableAmenity = CoreDoc & {
  __typename?: 'AvailableAmenity';
  _id: Scalars['ID']['output'];
  createdBy?: Maybe<CreateData>;
  customerId: Scalars['ID']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  spaceTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedBy?: Maybe<CreateData>;
};

export type AvailableStatus = {
  __typename?: 'AvailableStatus';
  _id: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum Background_Type {
  Colour = 'COLOUR',
  Image = 'IMAGE'
}

export enum Booking_Method {
  None = 'NONE',
  Pin = 'PIN',
  QrCode = 'QR_CODE'
}

export type BadgeNumberUser = {
  __typename?: 'BadgeNumberUser';
  _id: Scalars['ID']['output'];
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
};

export type BookedByData = {
  __typename?: 'BookedByData';
  bookerId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BookedByDataInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Booking = {
  __typename?: 'Booking';
  _id?: Maybe<Scalars['ID']['output']>;
  agenda?: Maybe<Scalars['String']['output']>;
  attendees?: Maybe<Array<Maybe<BookingAttendee>>>;
  bookedBy?: Maybe<BookedByData>;
  bookedFor?: Maybe<BookedByData>;
  bookingMethod?: Maybe<BookingMethod>;
  /**
   * The spaces saved on the booking.
   * These won't resolve any extra data
   */
  bookingSpaces?: Maybe<Array<Maybe<BookingSpace>>>;
  bookingType?: Maybe<BookingType>;
  /**
   * Gives you a true of false value which specifies ehether or not a desk booking can be checked into
   * The method should be "web" or "phone" or "panel"
   */
  canCheckInto?: Maybe<CheckInAction>;
  /** @deprecated centre shouldn't be used, use costCentre instead */
  centre?: Maybe<Scalars['String']['output']>;
  checkInTime?: Maybe<Scalars['String']['output']>;
  checkOutTime?: Maybe<Scalars['String']['output']>;
  checkedIn?: Maybe<Scalars['Boolean']['output']>;
  checkedOut?: Maybe<Scalars['Boolean']['output']>;
  costCentre?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  databaseId?: Maybe<Scalars['ID']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  endTimeInTimezone?: Maybe<Scalars['String']['output']>;
  exisitingDailyPass?: Maybe<DailyPass>;
  floor?: Maybe<Floor>;
  floorId?: Maybe<Scalars['ID']['output']>;
  iCalUId?: Maybe<Scalars['String']['output']>;
  isAllDay?: Maybe<Scalars['Boolean']['output']>;
  isAnonymised?: Maybe<Scalars['Boolean']['output']>;
  isLinkedRoomBooking?: Maybe<Scalars['Boolean']['output']>;
  isMultiDayBooking?: Maybe<Scalars['Boolean']['output']>;
  isOnlineMeeting?: Maybe<Scalars['Boolean']['output']>;
  isPostMeeting?: Maybe<Scalars['Boolean']['output']>;
  isPreMeeting?: Maybe<Scalars['Boolean']['output']>;
  isPrePostBooking?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isRecurringInstance?: Maybe<Scalars['Boolean']['output']>;
  leadBookingId?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationText?: Maybe<Scalars['String']['output']>;
  meetingLabel?: Maybe<Scalars['ID']['output']>;
  onlineMeetingUrl?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  recurrence?: Maybe<Recurrence>;
  released?: Maybe<Scalars['Boolean']['output']>;
  releasedBy?: Maybe<BookedByData>;
  releasedTime?: Maybe<Scalars['String']['output']>;
  releasedTimeInTimezone?: Maybe<Scalars['String']['output']>;
  /** A list of jobs requested as part of the booking */
  request?: Maybe<Request>;
  requestId?: Maybe<Scalars['ID']['output']>;
  requireDailyPass?: Maybe<Scalars['Boolean']['output']>;
  requiresApproval?: Maybe<Scalars['Boolean']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  seriesMasterBookingId?: Maybe<Scalars['String']['output']>;
  seriesMasterId?: Maybe<Scalars['String']['output']>;
  seriesMasterStartTime?: Maybe<Scalars['Date']['output']>;
  slotId?: Maybe<Scalars['String']['output']>;
  space?: Maybe<Space>;
  spaceId?: Maybe<Scalars['ID']['output']>;
  spaceLabel?: Maybe<SpaceLabel>;
  spaces?: Maybe<Array<Maybe<Space>>>;
  startTime?: Maybe<Scalars['Date']['output']>;
  startTimeInTimezone?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  timezoneId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Space>;
  zoneId?: Maybe<Scalars['ID']['output']>;
};


export type BookingCanCheckIntoArgs = {
  method: Scalars['String']['input'];
};

export type BookingAttendee = {
  __typename?: 'BookingAttendee';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isHost?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BookingExists = {
  __typename?: 'BookingExists';
  exists?: Maybe<Scalars['Boolean']['output']>;
};

export type BookingInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  agenda?: InputMaybe<Scalars['String']['input']>;
  attendeeCount?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<InputBookingAttendee>>>;
  bookedBy?: InputMaybe<BookedByDataInput>;
  bookedFor?: InputMaybe<BookedByDataInput>;
  bookingType: Scalars['String']['input'];
  checkInByTime?: InputMaybe<Scalars['String']['input']>;
  checkInTime?: InputMaybe<Scalars['String']['input']>;
  checkedIn?: InputMaybe<Scalars['Boolean']['input']>;
  costCentre?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  floorId: Scalars['ID']['input'];
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  jobMetadata?: InputMaybe<Array<InputMaybe<JobMetadataInput>>>;
  jobs?: InputMaybe<Array<InputMaybe<InputJob>>>;
  locationId: Scalars['ID']['input'];
  meetingLabel?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<InputRecurrence>;
  seriesMasterId?: InputMaybe<Scalars['String']['input']>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  /** A workspace booking requires a spaceId */
  spaceId?: InputMaybe<Scalars['ID']['input']>;
  /** A room booking requires spaces */
  spaces?: InputMaybe<Array<InputMaybe<InputBookingSpace>>>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  timezoneId?: InputMaybe<Scalars['String']['input']>;
  updateSeriesMaster?: InputMaybe<Scalars['Boolean']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BookingMethod {
  Phone = 'phone',
  Screen = 'screen',
  SpacesWeb = 'spacesWeb'
}

export type BookingOccupancy = {
  __typename?: 'BookingOccupancy';
  _id?: Maybe<Scalars['ID']['output']>;
  bookings?: Maybe<Array<Maybe<Booking>>>;
  dailyPass?: Maybe<DailyPass>;
  dailyPassStatus?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isFireMarshall?: Maybe<Scalars['Boolean']['output']>;
  isFirstAider?: Maybe<Scalars['Boolean']['output']>;
  isVisitor?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BookingOccupancyViewType>;
};

export type BookingOccupancyDailyPassStats = {
  __typename?: 'BookingOccupancyDailyPassStats';
  failed?: Maybe<Scalars['Int']['output']>;
  incomplete?: Maybe<Scalars['Int']['output']>;
  passed?: Maybe<Scalars['Int']['output']>;
};

export type BookingOccupancyInOfficeStats = {
  __typename?: 'BookingOccupancyInOfficeStats';
  checkedIn?: Maybe<Scalars['Int']['output']>;
  checkedOut?: Maybe<Scalars['Int']['output']>;
  expected?: Maybe<Scalars['Int']['output']>;
};

export type BookingOccupancyNotInOfficeStats = {
  __typename?: 'BookingOccupancyNotInOfficeStats';
  noStatus?: Maybe<Scalars['Int']['output']>;
  outOfOffice?: Maybe<Scalars['Int']['output']>;
  workingElsewhere?: Maybe<Scalars['Int']['output']>;
  workingFromHome?: Maybe<Scalars['Int']['output']>;
};

export type BookingOccupancySpaceBookingStats = {
  __typename?: 'BookingOccupancySpaceBookingStats';
  deskBookings?: Maybe<Scalars['Int']['output']>;
  lockerBookings?: Maybe<Scalars['Int']['output']>;
  parkingBookings?: Maybe<Scalars['Int']['output']>;
};

export type BookingOccupancyStats = {
  __typename?: 'BookingOccupancyStats';
  dailyPasses?: Maybe<BookingOccupancyDailyPassStats>;
  inOffice?: Maybe<BookingOccupancyInOfficeStats>;
  notInOffice?: Maybe<BookingOccupancyNotInOfficeStats>;
  spacesBooking?: Maybe<BookingOccupancySpaceBookingStats>;
};

export enum BookingOccupancyViewType {
  All = 'All',
  InOffice = 'InOffice',
  NotInOffice = 'NotInOffice'
}

export type BookingOccupancyWithStats = {
  __typename?: 'BookingOccupancyWithStats';
  bookingOccupancy?: Maybe<Array<Maybe<BookingOccupancy>>>;
  stats?: Maybe<BookingOccupancyStats>;
};

export type BookingSlot = {
  __typename?: 'BookingSlot';
  booking?: Maybe<Booking>;
  canBeBooked?: Maybe<Scalars['Boolean']['output']>;
  checkInTime?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slotId?: Maybe<Scalars['ID']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BookingSlotTemplate = {
  __typename?: 'BookingSlotTemplate';
  _id?: Maybe<Scalars['String']['output']>;
  bookingMode?: Maybe<Scalars['String']['output']>;
  bookingSlots?: Maybe<Array<Maybe<BookingSlot>>>;
  slotsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type BookingSpace = {
  __typename?: 'BookingSpace';
  email?: Maybe<Scalars['String']['output']>;
  floorId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
};

export type BookingStatusSummary = {
  __typename?: 'BookingStatusSummary';
  _id?: Maybe<Scalars['ID']['output']>;
  bookingType?: Maybe<Scalars['String']['output']>;
  canCancel?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives you a true of false value which specifies ehether or not a desk booking can be checked into
   * The method should be "web" or "phone" or "panel"
   */
  canCheckInto?: Maybe<CheckInAction>;
  checkedIn?: Maybe<Scalars['Boolean']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  dailyPassQuestions?: Maybe<Array<Maybe<DailyPassQuestion>>>;
  endTime?: Maybe<Scalars['String']['output']>;
  endTimeInTimezone?: Maybe<Scalars['String']['output']>;
  exisitingDailyPass?: Maybe<DailyPass>;
  floor?: Maybe<Floor>;
  location?: Maybe<Location>;
  released?: Maybe<Scalars['Boolean']['output']>;
  releasedTime?: Maybe<Scalars['String']['output']>;
  releasedTimeInTimezone?: Maybe<Scalars['String']['output']>;
  requireDailyPass?: Maybe<Scalars['Boolean']['output']>;
  space?: Maybe<Space>;
  startTime?: Maybe<Scalars['String']['output']>;
  startTimeInTimezone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AvailableStatus>;
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SummaryType>;
  zone?: Maybe<Space>;
};


export type BookingStatusSummaryCanCheckIntoArgs = {
  method: Scalars['String']['input'];
};

export type BookingSummary = {
  __typename?: 'BookingSummary';
  bookingType?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['Date']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  spaceName?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AvailableStatus>;
  type?: Maybe<Scalars['String']['output']>;
  zoneName?: Maybe<Scalars['String']['output']>;
};

export enum BookingType {
  BookingAndArrival = 'bookingAndArrival',
  Configuration = 'configuration',
  Desk = 'desk',
  DeskOnArrival = 'deskOnArrival',
  DeskOnBooking = 'deskOnBooking',
  Location = 'location',
  Locker = 'locker',
  Meetingroom = 'meetingroom',
  Parking = 'parking'
}

export type BookingsAndSpaceAvailabilities = {
  __typename?: 'BookingsAndSpaceAvailabilities';
  customerId?: Maybe<Scalars['ID']['output']>;
  permissions?: Maybe<SpacePermissions>;
  roomBookings?: Maybe<Array<Maybe<Booking>>>;
  roomStatus?: Maybe<RoomStatus>;
  /** resolvefields */
  space?: Maybe<Space>;
  spaceId?: Maybe<Scalars['ID']['output']>;
  spaceIsFavourite?: Maybe<Scalars['Boolean']['output']>;
};

export enum Connection_Type {
  InteractiveWayfinder = 'INTERACTIVE_WAYFINDER',
  Room = 'ROOM',
  SelectType = 'SELECT_TYPE',
  Visitor = 'VISITOR',
  VisitorKiosk = 'VISITOR_KIOSK',
  Wayfinder = 'WAYFINDER',
  WayfinderV2 = 'WAYFINDER_V2'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CancelBookingResponse = {
  __typename?: 'CancelBookingResponse';
  id?: Maybe<Scalars['String']['output']>;
};

export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  autoCancelDeskBookings?: Maybe<Scalars['Boolean']['output']>;
  autoCancelDeskBookingsAfterCheckIn?: Maybe<Scalars['Boolean']['output']>;
  autoCancelDeskBookingsAfterCheckInMinutes?: Maybe<Scalars['Int']['output']>;
  autoCancelMeetings?: Maybe<Scalars['Boolean']['output']>;
  autoCancelMeetingsAfterCheckIn?: Maybe<Scalars['Boolean']['output']>;
  autoCancelMeetingsAfterCheckInMinutes?: Maybe<Scalars['Int']['output']>;
  deskCancellationMessage?: Maybe<Scalars['String']['output']>;
  ghostMeetingCancelType?: Maybe<Scalars['String']['output']>;
  minutesUntilCancel?: Maybe<Scalars['Int']['output']>;
  minutesUntilCancelDeskBooking?: Maybe<Scalars['Int']['output']>;
  showCustomDeskCancellationMessage?: Maybe<Scalars['Boolean']['output']>;
  zombieMeetingCancelType?: Maybe<Scalars['String']['output']>;
};

export type CheckIn = {
  __typename?: 'CheckIn';
  method?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export type CheckInAction = {
  __typename?: 'CheckInAction';
  /** Wheher or not the user can attempt to check into the booking */
  canAttemptCheckIn?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the client application the end result for whether the booking can be checked into. */
  canCheckIn?: Maybe<Scalars['Boolean']['output']>;
  /** Tells the user when a booking can be checked into (currently only available for meeting room bookings). */
  checkInTime?: Maybe<Scalars['Date']['output']>;
  /** The time the user can check into the booking until (currently only available for meeting room bookings). */
  checkInUntilTime?: Maybe<Scalars['Date']['output']>;
  /** The max distance a user can be from the location they are checking into */
  maxDistanceToLocation?: Maybe<Scalars['Int']['output']>;
  /** Tells the client application whether or not to start the daily pass process */
  requireDailyPass?: Maybe<Scalars['Boolean']['output']>;
  /** Tells the client application whether or not to start the location access form process */
  requireLocationAccessForm?: Maybe<Scalars['Boolean']['output']>;
  /** Tells the client application whether or not the users distance should be checked */
  requireLocationDistanceCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Tells the client application whether the user is required to scan a QR code to check into the booking */
  requireQRScan?: Maybe<Scalars['Boolean']['output']>;
};

export enum CheckInStatus {
  CheckedIn = 'checkedIn',
  CheckedOut = 'checkedOut'
}

export type ClearJobsResponse = {
  __typename?: 'ClearJobsResponse';
  affected?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfigurationInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  backgroundColour?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  backgroundType?: InputMaybe<Scalars['String']['input']>;
  bookingMethod?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  disableInteractivity?: InputMaybe<Scalars['Boolean']['input']>;
  displayTouch?: InputMaybe<Scalars['Boolean']['input']>;
  floorId?: InputMaybe<Scalars['String']['input']>;
  inactiveChance?: InputMaybe<Scalars['String']['input']>;
  interactive?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  themeColour?: InputMaybe<Scalars['String']['input']>;
  /** Current screen connection type e.g. room-panel */
  type?: InputMaybe<Connection_Type>;
  welcomeDescription?: InputMaybe<Scalars['String']['input']>;
  welcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ConfiguredIntegration = {
  __typename?: 'ConfiguredIntegration';
  _id?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  integrationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<ConfiguredIntegrationOption>;
};

export type ConfiguredIntegrationInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ConfiguredIntegrationOptionInput>;
};

export type ConfiguredIntegrationOption = {
  __typename?: 'ConfiguredIntegrationOption';
  adminEmail?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  authenticationUrl?: Maybe<Scalars['String']['output']>;
  clientDomain?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  graphUrl?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscriptionKey?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type ConfiguredIntegrationOptionInput = {
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  authenticationUrl?: InputMaybe<Scalars['String']['input']>;
  clientDomain?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  graphUrl?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<Scalars['String']['input']>;
  subscriptionKey?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectScreenInput = {
  /** Configuration information for the screen. This will control the look, feel and behavior */
  configuration?: InputMaybe<ConfigurationInput>;
  /** Code displayed on the screen for connection */
  connectionCode: Scalars['String']['input'];
  connectionStatus?: InputMaybe<Scalars['String']['input']>;
  /** Something to describe the screen connection */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Location ID of the screen */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /** Something to help remember the screen connection */
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  _id?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Ability to resolve all the responses for a single conversation
   * this should only be used when getting a single conversation at a time
   */
  responses?: Maybe<Array<Maybe<AssistantResponse>>>;
};

export type CoreDoc = {
  _id: Scalars['ID']['output'];
  createdBy?: Maybe<CreateData>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  updatedBy?: Maybe<CreateData>;
};

export type CreateBookingError = {
  __typename?: 'CreateBookingError';
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type CreateBookingResponse = {
  __typename?: 'CreateBookingResponse';
  booking?: Maybe<Booking>;
  error?: Maybe<CreateBookingError>;
};

/**
 * All created and edited data implements this type.
 * It provides a standard structure to the createdBy, updatedBy and deletedBy objects
 */
export type CreateData = {
  __typename?: 'CreateData';
  _id?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export type CreateJobInput = {
  jobItemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Update_Job_Status>;
  userValue?: InputMaybe<Scalars['String']['input']>;
};

export enum CreateMethod {
  Admin = 'admin',
  Panel = 'panel',
  Registration = 'registration'
}

export type CreateRequestInput = {
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<Array<InputMaybe<CreateJobInput>>>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Request_Priority>;
};

export type CreateRequestResponse = {
  __typename?: 'CreateRequestResponse';
  jobs?: Maybe<Array<Maybe<Job>>>;
  request?: Maybe<Request>;
};

/** An object that stores information related to the custom message template for desk booking/daily pass reminders */
export type CustomMessage = CoreDoc & {
  __typename?: 'CustomMessage';
  _id: Scalars['ID']['output'];
  createdBy?: Maybe<CreateData>;
  customerId: Scalars['ID']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  hour?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
};

export type Customer = {
  __typename?: 'Customer';
  _id: Scalars['ID']['output'];
  allowedDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  banner?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<CreateData>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  friendlyId?: Maybe<Scalars['String']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  isTrial?: Maybe<Scalars['Boolean']['output']>;
  loginMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  navItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pricingModel?: Maybe<PricingModel>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  security?: Maybe<Security>;
  subscription?: Maybe<CustomerSubscription>;
  tenantId?: Maybe<Scalars['String']['output']>;
  textOnPrimaryColor?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
  venueGroups?: Maybe<Array<Maybe<VenueGroup>>>;
};

export type CustomerAccess = {
  __typename?: 'CustomerAccess';
  _id?: Maybe<Scalars['ID']['output']>;
  customers?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  spacesAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerSubscription = {
  __typename?: 'CustomerSubscription';
  features?: Maybe<Array<Maybe<CustomerSubscriptionFeature>>>;
  isTrial?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerSubscriptionFeature = {
  __typename?: 'CustomerSubscriptionFeature';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export enum Dashboard_Category {
  Employee = 'employee',
  HybridWorking = 'hybrid_working',
  Iot = 'iot',
  Occupancy = 'occupancy',
  Other = 'other',
  Services = 'services',
  Utilisation = 'utilisation',
  Visitors = 'visitors'
}

export enum Dashboard_Type {
  App = 'app',
  Looker = 'looker'
}

export type DailyPass = {
  __typename?: 'DailyPass';
  _id?: Maybe<Scalars['ID']['output']>;
  createdBy?: Maybe<CreateData>;
  customerId?: Maybe<Scalars['ID']['output']>;
  dailyPassUser?: Maybe<DailyPassUser>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<CreateData>;
  fullLocation?: Maybe<Location>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  updatedBy?: Maybe<CreateData>;
  userId?: Maybe<Scalars['ID']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
  visitId?: Maybe<Scalars['ID']['output']>;
  visitorId?: Maybe<Scalars['ID']['output']>;
};

export type DailyPassConfig = {
  __typename?: 'DailyPassConfig';
  autoCancelDeskBookingsWhenDailyPassFailed?: Maybe<Scalars['Boolean']['output']>;
  autoCancelParkingBookingsWhenDailyPassFailed?: Maybe<Scalars['Boolean']['output']>;
  daysLimit?: Maybe<Scalars['Int']['output']>;
  hasDefaultQuestions?: Maybe<Scalars['Boolean']['output']>;
  invalidPassMessage?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<Maybe<DailyPassQuestion>>>;
  showCustomInvalidPassMessage?: Maybe<Scalars['Boolean']['output']>;
};

export type DailyPassQuestion = {
  __typename?: 'DailyPassQuestion';
  acceptableOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allowAcceptableOptionsChange?: Maybe<Scalars['Boolean']['output']>;
  allowRemove?: Maybe<Scalars['Boolean']['output']>;
  allowRequiredChange?: Maybe<Scalars['Boolean']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  hasAcceptableOptions?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  showWHOGuidance?: Maybe<Scalars['Boolean']['output']>;
};

export type DailyPassUser = {
  __typename?: 'DailyPassUser';
  _id: Scalars['ID']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  _id?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Dashboard_Category>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Dashboard_Type>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DaySummary = {
  __typename?: 'DaySummary';
  day?: Maybe<Scalars['Date']['output']>;
  items?: Maybe<Array<Maybe<BookingStatusSummary>>>;
};

export type DefaultDisplayConfiguration = {
  __typename?: 'DefaultDisplayConfiguration';
  _id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Connection_Type>;
};

export type DelegatesForEmployee = {
  __typename?: 'DelegatesForEmployee';
  admins?: Maybe<Array<Maybe<Employee>>>;
  employee?: Maybe<Employee>;
};

export enum DeleteMethod {
  BookingCreated = 'bookingCreated',
  StatusUpdated = 'statusUpdated'
}

export type DeskPolicy = {
  __typename?: 'DeskPolicy';
  allowCustomHalfDaySlotColor?: Maybe<Scalars['Boolean']['output']>;
  allowDeskQRBooking?: Maybe<Scalars['Boolean']['output']>;
  allowDesktopCheckIn?: Maybe<Scalars['Boolean']['output']>;
  allowFutureDeskBookings?: Maybe<Scalars['Boolean']['output']>;
  allowPhoneCheckIn?: Maybe<Scalars['Boolean']['output']>;
  bookingSlots?: Maybe<BookingSlotTemplate>;
  customHalfDayColour?: Maybe<Scalars['String']['output']>;
  daysDesksCanBeBookedInFuture?: Maybe<Scalars['Int']['output']>;
  maxNumberAssignedToDesk?: Maybe<Scalars['Int']['output']>;
  maxSingleDayDeskBookings?: Maybe<Scalars['Int']['output']>;
  maxWeeklyDeskBookingCount?: Maybe<Scalars['Int']['output']>;
  minMetersToCheckInOnDesktop?: Maybe<Scalars['Int']['output']>;
  nearbyDeskDisable?: Maybe<Scalars['Boolean']['output']>;
  requireAccessSurvey?: Maybe<Scalars['Boolean']['output']>;
  requireDeskAssign?: Maybe<Scalars['Boolean']['output']>;
  requireLocationCheckDesktop?: Maybe<Scalars['Boolean']['output']>;
  requirePhoneQRScan?: Maybe<Scalars['Boolean']['output']>;
  restrictBookingsToFloorMaximumCapacity?: Maybe<Scalars['Boolean']['output']>;
  restrictDayDeskBookingCount?: Maybe<Scalars['Boolean']['output']>;
  restrictWeeklyDeskBookingCount?: Maybe<Scalars['Boolean']['output']>;
  timeFutureDeskBookingIsEnabled?: Maybe<Scalars['String']['output']>;
};

export type EmergencyList = CoreDoc & {
  __typename?: 'EmergencyList';
  _id: Scalars['ID']['output'];
  createdBy?: Maybe<CreateData>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  customerId: Scalars['ID']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<CreateData>;
  isTempList?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  locationId: Scalars['ID']['output'];
  updatedBy?: Maybe<CreateData>;
  visitors?: Maybe<Array<Maybe<EmergencyVisitor>>>;
};

export type EmergencyVisitor = {
  __typename?: 'EmergencyVisitor';
  firstName?: Maybe<Scalars['String']['output']>;
  isAccountedFor?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  signedInTime?: Maybe<Scalars['Date']['output']>;
  visitorId: Scalars['ID']['output'];
};

/**
 * A RICOH Spaces user, holds information such as email, ID and name.
 * An employee profile is also found
 */
export type Employee = {
  __typename?: 'Employee';
  _id: Scalars['ID']['output'];
  badgeNumber?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  completedAppOnboarding?: Maybe<Scalars['Boolean']['output']>;
  completedWebOnboarding?: Maybe<Scalars['Boolean']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<CreateData>;
  customerAccess?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  homeLocationId?: Maybe<Scalars['String']['output']>;
  homepage?: Maybe<Scalars['String']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  navigation?: Maybe<Scalars['String']['output']>;
  notificationPrefs?: Maybe<NotificationPrefs>;
  picture?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  productAnalytics?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  showAsHostOnVisitorApp?: Maybe<Scalars['Boolean']['output']>;
  tagLine?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  timeFormat?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
  userDelegates?: Maybe<Array<Maybe<UserDelegate>>>;
  userPrincipalName?: Maybe<Scalars['String']['output']>;
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  views?: Maybe<Array<Maybe<View>>>;
};

export type EmployeeDaySummary = {
  __typename?: 'EmployeeDaySummary';
  day?: Maybe<Scalars['Date']['output']>;
  items?: Maybe<Array<Maybe<BookingSummary>>>;
};

/** All the data points to update an employee. */
export type EmployeeInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  completedAppOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  completedWebOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customerAccess?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homeLocationId?: InputMaybe<Scalars['String']['input']>;
  homepage?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<Scalars['String']['input']>;
  notificationPrefs?: InputMaybe<NotificationPrefsInput>;
  picture?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  productAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  showAsHostOnVisitorApp?: InputMaybe<Scalars['Boolean']['input']>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  timeFormat?: InputMaybe<Scalars['String']['input']>;
  userDelegates?: InputMaybe<Array<InputMaybe<InputUserDelegate>>>;
  userPrincipalName?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Array<InputMaybe<InputView>>>;
};

export type EmployeesPolicy = {
  __typename?: 'EmployeesPolicy';
  dailyPass?: Maybe<DailyPassConfig>;
  requireDailyPass?: Maybe<Scalars['Boolean']['output']>;
};

export type EventAvailability = {
  __typename?: 'EventAvailability';
  allBookings?: Maybe<Array<Maybe<Booking>>>;
  available?: Maybe<Scalars['Boolean']['output']>;
  currentBooking?: Maybe<Booking>;
  nextBooking?: Maybe<Booking>;
  nextBookings?: Maybe<Booking>;
  todaysBookings?: Maybe<Array<Maybe<Booking>>>;
  totalEvents?: Maybe<Array<Maybe<Booking>>>;
};

export type FeedbackResponseInput = {
  harmful?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  type: FeedbackResponseType;
  unhelpful?: InputMaybe<Scalars['Boolean']['input']>;
  untrue?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FeedbackResponseType {
  Negative = 'negative',
  Positive = 'positive'
}

/**
 * A floor is a simply object that holds the name, number and order of the floor.
 * It also holds other information such the floorplan URL, floorplan image and max capacity values
 */
export type Floor = CoreDoc & {
  __typename?: 'Floor';
  _id: Scalars['ID']['output'];
  capacity?: Maybe<FloorCapacity>;
  createdBy?: Maybe<CreateData>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  floorPlan?: Maybe<FloorFloorplan>;
  floorPlanImage?: Maybe<Scalars['String']['output']>;
  isAtCapacity?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  mapImage?: Maybe<Scalars['String']['output']>;
  mapOrientation?: Maybe<Scalars['Int']['output']>;
  mapsPeopleId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
};


/**
 * A floor is a simply object that holds the name, number and order of the floor.
 * It also holds other information such the floorplan URL, floorplan image and max capacity values
 */
export type FloorIsAtCapacityArgs = {
  date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type FloorCapacity = {
  __typename?: 'FloorCapacity';
  designedCapacity?: Maybe<Scalars['Int']['output']>;
  maxCapacity?: Maybe<Scalars['Int']['output']>;
  targetCapacity?: Maybe<Scalars['Int']['output']>;
};

export type FloorFloorplan = {
  __typename?: 'FloorFloorplan';
  floorPlan?: Maybe<Scalars['String']['output']>;
  floorPlanUrl?: Maybe<Scalars['String']['output']>;
};

export type FloorOrderUpdate = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type FloorPlanSvg = {
  __typename?: 'FloorPlanSVG';
  svg: Scalars['String']['output'];
};

export type GetJobsInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};

/** A document that lists information about a group */
export type Group = CoreDoc & {
  __typename?: 'Group';
  _id: Scalars['ID']['output'];
  createdBy?: Maybe<CreateData>;
  customerId: Scalars['ID']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<CreateData>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isADGroup?: Maybe<Scalars['Boolean']['output']>;
  isLoop?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Return a list of members assigned to the group
   * Should only be used for a single group or small list
   */
  members?: Maybe<Array<Maybe<Employee>>>;
  name?: Maybe<Scalars['String']['output']>;
  showInSpaces?: Maybe<Scalars['Boolean']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
};

export type GroupedLocations = {
  __typename?: 'GroupedLocations';
  /** If a location has an associated Venue group it and all locations with the matching group will be returned here */
  groupedLocations?: Maybe<Array<Maybe<VenueGroupedLocations>>>;
  /** Any location without an associated venue group with be returned here */
  nonGroupedLocations?: Maybe<Array<Maybe<Location>>>;
};

export type IdToken = {
  __typename?: 'IDToken';
  expiresIn?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  identityTenant?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  userHash?: Maybe<Scalars['String']['output']>;
};

export enum Inactive_Chance {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/**
 * All created and edited data implements this type.
 * It provides a standard structure to the createdBy, updatedBy and deletedBy objects
 */
export type IotCreateData = {
  __typename?: 'IOTCreateData';
  _id: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export type InOfficePolicy = {
  __typename?: 'InOfficePolicy';
  allowDeskQRBooking?: Maybe<Scalars['Boolean']['output']>;
  allowDesktopCheckIn?: Maybe<Scalars['Boolean']['output']>;
  allowInOfficeStatus?: Maybe<Scalars['Boolean']['output']>;
  allowPhoneCheckIn?: Maybe<Scalars['Boolean']['output']>;
  bookingSlots?: Maybe<BookingSlotTemplate>;
  daysInOfficeCanBeBookedInFuture?: Maybe<Scalars['Int']['output']>;
  minMetersToCheckInOnDesktop?: Maybe<Scalars['Int']['output']>;
  requireLocationCheckDesktop?: Maybe<Scalars['Boolean']['output']>;
  requirePhoneQRScan?: Maybe<Scalars['Boolean']['output']>;
};

export type InputAllowedDay = {
  day?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputAmenity = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputBookingAttendee = {
  createVisit?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputBookingSlot = {
  checkInTime?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputBookingSlotTemplate = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  bookingMode?: InputMaybe<Scalars['String']['input']>;
  bookingSlots?: InputMaybe<Array<InputMaybe<InputBookingSlot>>>;
  slotsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputBookingSpace = {
  email?: InputMaybe<Scalars['String']['input']>;
  floorId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputBulkCreateSpaceFromFloorplan = {
  floorId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  spaces: Array<InputMaybe<InputSpaceFloorplanIdAndType>>;
};

export type InputBulkSpaceUpdate = {
  amenities?: InputMaybe<Array<InputMaybe<SelectedAmenity>>>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  floorId?: InputMaybe<Scalars['String']['input']>;
  spaceIds: Array<InputMaybe<Scalars['String']['input']>>;
  updateAmenities?: InputMaybe<Scalars['Boolean']['input']>;
  updateStatuses?: InputMaybe<Scalars['Boolean']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type InputCancellationPolicy = {
  autoCancelDeskBookings?: InputMaybe<Scalars['Boolean']['input']>;
  autoCancelDeskBookingsAfterCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  autoCancelDeskBookingsAfterCheckInMinutes?: InputMaybe<Scalars['Int']['input']>;
  autoCancelMeetings?: InputMaybe<Scalars['Boolean']['input']>;
  autoCancelMeetingsAfterCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  autoCancelMeetingsAfterCheckInMinutes?: InputMaybe<Scalars['Int']['input']>;
  deskCancellationMessage?: InputMaybe<Scalars['String']['input']>;
  ghostMeetingCancelType?: InputMaybe<Scalars['String']['input']>;
  minutesUntilCancel?: InputMaybe<Scalars['Int']['input']>;
  minutesUntilCancelDeskBooking?: InputMaybe<Scalars['Int']['input']>;
  showCustomDeskCancellationMessage?: InputMaybe<Scalars['Boolean']['input']>;
  zombieMeetingCancelType?: InputMaybe<Scalars['String']['input']>;
};

export type InputCsvVisit = {
  email: Scalars['String']['input'];
  expectedDate: Scalars['Date']['input'];
  expectedEnd: Scalars['Date']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  visitingEmail?: InputMaybe<Scalars['String']['input']>;
};

/** The information that can be used to create or update a customMessage */
export type InputCustomMessage = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  hour?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputCustomer = {
  _id: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  security?: InputMaybe<SecurityInput>;
};

export type InputCustomerAccess = {
  customers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputDailyPass = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  validFrom?: InputMaybe<Scalars['String']['input']>;
  validTo?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
  visitorId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputDailyPassConfig = {
  autoCancelDeskBookingsWhenDailyPassFailed?: InputMaybe<Scalars['Boolean']['input']>;
  autoCancelParkingBookingsWhenDailyPassFailed?: InputMaybe<Scalars['Boolean']['input']>;
  daysLimit?: InputMaybe<Scalars['Int']['input']>;
  hasDefaultQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  invalidPassMessage?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<InputMaybe<InputDailyPassQuestion>>>;
  showCustomInvalidPassMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDailyPassQuestion = {
  acceptableOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowAcceptableOptionsChange?: InputMaybe<Scalars['Boolean']['input']>;
  allowRemove?: InputMaybe<Scalars['Boolean']['input']>;
  allowRequiredChange?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  hasAcceptableOptions?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  showWHOGuidance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDeskPolicy = {
  allowCustomHalfDaySlotColor?: InputMaybe<Scalars['Boolean']['input']>;
  allowDeskQRBooking?: InputMaybe<Scalars['Boolean']['input']>;
  allowDesktopCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  allowFutureDeskBookings?: InputMaybe<Scalars['Boolean']['input']>;
  allowPhoneCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  bookingSlots?: InputMaybe<InputBookingSlotTemplate>;
  customHalfDayColour?: InputMaybe<Scalars['String']['input']>;
  daysDesksCanBeBookedInFuture?: InputMaybe<Scalars['Int']['input']>;
  maxNumberAssignedToDesk?: InputMaybe<Scalars['Int']['input']>;
  maxSingleDayDeskBookings?: InputMaybe<Scalars['Int']['input']>;
  maxWeeklyDeskBookingCount?: InputMaybe<Scalars['Int']['input']>;
  minMetersToCheckInOnDesktop?: InputMaybe<Scalars['Int']['input']>;
  nearbyDeskDisable?: InputMaybe<Scalars['Boolean']['input']>;
  requireAccessSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  requireDeskAssign?: InputMaybe<Scalars['Boolean']['input']>;
  requireLocationCheckDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhoneQRScan?: InputMaybe<Scalars['Boolean']['input']>;
  restrictBookingsToFloorMaximumCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  restrictDayDeskBookingCount?: InputMaybe<Scalars['Boolean']['input']>;
  restrictWeeklyDeskBookingCount?: InputMaybe<Scalars['Boolean']['input']>;
  timeFutureDeskBookingIsEnabled?: InputMaybe<Scalars['String']['input']>;
};

export type InputEmergencyList = {
  _id: Scalars['ID']['input'];
  visitors: Array<InputMaybe<InputEmergencyVisitor>>;
};

export type InputEmergencyVisitor = {
  isAccountedFor?: InputMaybe<Scalars['Boolean']['input']>;
  visitorId: Scalars['ID']['input'];
};

export type InputEmployeesPolicy = {
  dailyPass?: InputMaybe<InputDailyPassConfig>;
  requireDailyPass?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A new floor object. The ID could be provided if the floor is being updated but is empty during creation */
export type InputFloor = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  capacity?: InputMaybe<InputFloorCapacity>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  floorPlan?: InputMaybe<InputFloorFloorplan>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  mapImage?: InputMaybe<Scalars['String']['input']>;
  mapOrientation?: InputMaybe<Scalars['Int']['input']>;
  mapsPeopleId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputFloorCapacity = {
  designedCapacity?: InputMaybe<Scalars['Int']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  targetCapacity?: InputMaybe<Scalars['Int']['input']>;
};

export type InputFloorFloorplan = {
  floorPlan?: InputMaybe<Scalars['String']['input']>;
  floorPlanUrl?: InputMaybe<Scalars['String']['input']>;
};

export type InputFullCustomer = {
  allowedDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  banner?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  loginMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingModel?: InputMaybe<PricingModel>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  security?: InputMaybe<SecurityInput>;
  subscription?: InputMaybe<SubscriptionInput>;
  textOnPrimaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type InputGroup = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isADGroup: Scalars['Boolean']['input'];
  isLoop: Scalars['Boolean']['input'];
  isPrivate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  showInSpaces: Scalars['Boolean']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type InputGroupMembersUpdate = {
  added?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  removed?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type InputInOfficePolicy = {
  allowDeskQRBooking?: InputMaybe<Scalars['Boolean']['input']>;
  allowDesktopCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  allowInOfficeStatus?: InputMaybe<Scalars['Boolean']['input']>;
  allowPhoneCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  bookingSlots?: InputMaybe<InputBookingSlotTemplate>;
  daysInOfficeCanBeBookedInFuture?: InputMaybe<Scalars['Int']['input']>;
  minMetersToCheckInOnDesktop?: InputMaybe<Scalars['Int']['input']>;
  requireLocationCheckDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  requirePhoneQRScan?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The space information that can be used to create or update a location */
export type InputIotDevice = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputJob = {
  jobItemId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** The location information that can be used to create or update a location */
export type InputLocation = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<InputLocationAddress>;
  capacity?: InputMaybe<InputLocationCapacity>;
  googleBuildingId?: InputMaybe<Scalars['String']['input']>;
  hasAdvancedMap?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  mapImage?: InputMaybe<Scalars['String']['input']>;
  mapwizeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  o365Integration?: InputMaybe<Scalars['String']['input']>;
  officeHours?: InputMaybe<Array<InputMaybe<InputOfficeHour>>>;
  outlookRoomAddress?: InputMaybe<Scalars['String']['input']>;
  timezoneId?: InputMaybe<Scalars['String']['input']>;
  tzTimezone?: InputMaybe<Scalars['String']['input']>;
  venueGroup?: InputMaybe<InputVenueGroup>;
};

export type InputLocationAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapsUrl?: InputMaybe<Scalars['String']['input']>;
  plusCode?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
};

export type InputLocationCapacity = {
  designedCapacity?: InputMaybe<Scalars['Int']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  targetCapacity?: InputMaybe<Scalars['Int']['input']>;
};

export type InputMeetingRoomPolicy = {
  allowCancelFromPanel?: InputMaybe<Scalars['Boolean']['input']>;
  allowEarlyCheckOutFromPanel?: InputMaybe<Scalars['Boolean']['input']>;
  maxRecurringInstances?: InputMaybe<Scalars['Int']['input']>;
  minutesAfterCheckIn?: InputMaybe<Scalars['Int']['input']>;
  minutesBeforeCheckIn?: InputMaybe<Scalars['Int']['input']>;
  requireCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputNearbyDesk = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputOfficeHour = {
  day?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type InputParkingPolicy = {
  allowFutureParkingBookings?: InputMaybe<Scalars['Boolean']['input']>;
  daysParkingCanBeBookedInFuture?: InputMaybe<Scalars['Int']['input']>;
  maxNumberAssignedToParking?: InputMaybe<Scalars['Int']['input']>;
  maxSingleDayParkingBookings?: InputMaybe<Scalars['Int']['input']>;
  requireParkingAssign?: InputMaybe<Scalars['Boolean']['input']>;
  restrictDayParkingBookingCount?: InputMaybe<Scalars['Boolean']['input']>;
  timeFutureParkingBookingIsEnabled?: InputMaybe<Scalars['String']['input']>;
};

export type InputPartialGroup = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputPolicy = {
  _id: Scalars['ID']['input'];
  cancellation?: InputMaybe<InputCancellationPolicy>;
  desks?: InputMaybe<InputDeskPolicy>;
  employee?: InputMaybe<InputEmployeesPolicy>;
  inOffice?: InputMaybe<InputInOfficePolicy>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  meetingRoom?: InputMaybe<InputMeetingRoomPolicy>;
  parking?: InputMaybe<InputParkingPolicy>;
  privacy?: InputMaybe<InputPrivacyPolicy>;
  visitor?: InputMaybe<InputVisitorPolicy>;
};

export type InputPrivacyPolicy = {
  daysBeforeDeskBookingAnonymisationTakesPlace?: InputMaybe<Scalars['Int']['input']>;
  daysBeforeVisitorAnonymisationTakesPlace?: InputMaybe<Scalars['Int']['input']>;
  deskBookingAnonymisationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  showEventTitleIfAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  visitorAnonymisationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputRecurrence = {
  pattern?: InputMaybe<InputRecurrencePattern>;
  range?: InputMaybe<InputRecurrenceRange>;
};

export type InputRecurrencePattern = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputRecurrenceRange = {
  numberOfOccurrences?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputRequiredSpace = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputSignIn = {
  method?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SignInStatus>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

/** The space information that can be used to create or update a location */
export type InputSpace = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<InputSpaceAmenity>>>;
  approvalsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  assignedGroups?: InputMaybe<Array<InputMaybe<InputSpaceAssignedGroup>>>;
  assignedUsers?: InputMaybe<Array<InputMaybe<InputSpaceAssignedUser>>>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookingJobItemId?: InputMaybe<Scalars['String']['input']>;
  bookingSlots?: InputMaybe<InputBookingSlotTemplate>;
  bookingType?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<SpaceCategory>;
  deletedSpacesInZone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endorsementEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  floorId?: InputMaybe<Scalars['String']['input']>;
  floorPlanId?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  limitBookingsToCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  lngLat?: InputMaybe<InputSpaceLngLat>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  mapboxId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nearbyDesks?: InputMaybe<Array<InputMaybe<InputNearbyDesk>>>;
  priceRange?: InputMaybe<PriceRange>;
  provider?: InputMaybe<Scalars['String']['input']>;
  requiredSpaces?: InputMaybe<Array<InputMaybe<InputRequiredSpace>>>;
  spaceType?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  useOccupancyAsAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type InputSpaceAmenity = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputSpaceAssignedGroup = {
  allowedDays?: InputMaybe<Array<InputMaybe<InputAllowedDay>>>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type InputSpaceAssignedUser = {
  allowedDays?: InputMaybe<Array<InputMaybe<InputAllowedDay>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputSpaceFloorplanIdAndType = {
  floorPlanId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type InputSpaceLabel = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  color: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InputSpaceLayout = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InputSpaceLngLat = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type InputUserDelegate = {
  deskBooking?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  parkingBooking?: InputMaybe<Scalars['Boolean']['input']>;
  roomBooking?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputUserStatus = {
  date: Scalars['Date']['input'];
  statusId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputVehicle = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isHybridElectric?: InputMaybe<Scalars['Boolean']['input']>;
  isPoolCar?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputVenueGroup = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputView = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['String']['input']>;
};

export type InputVisit = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  dailyPassEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  dailyPassEmailSentOn?: InputMaybe<Scalars['Date']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  expectedDate?: InputMaybe<Scalars['Date']['input']>;
  expectedEnd?: InputMaybe<Scalars['Date']['input']>;
  hasScannedPanelQR?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  registrationCompleted?: InputMaybe<Scalars['Date']['input']>;
  sendInvitation?: InputMaybe<Scalars['Boolean']['input']>;
  signInLog?: InputMaybe<Array<InputMaybe<InputSignIn>>>;
  visiting?: InputMaybe<InputVisiting>;
  visitor?: InputMaybe<InputVisitor>;
  visitorId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputVisiting = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type InputVisitor = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  carRegistration?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputVisitorDailyPass = {
  autoCancelDeskBookingsWhenDailyPassFailed?: InputMaybe<Scalars['Boolean']['input']>;
  autoCancelParkingBookingsWhenDailyPassFailed?: InputMaybe<Scalars['Boolean']['input']>;
  daysLimit?: InputMaybe<Scalars['Int']['input']>;
  hasDefaultQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  invalidPassMessage?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<InputMaybe<InputDailyPassQuestion>>>;
  showCustomInvalidPassMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputVisitorField = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputVisitorFields = {
  carReg?: InputMaybe<InputVisitorField>;
  company?: InputMaybe<InputVisitorField>;
  jobTitle?: InputMaybe<InputVisitorField>;
  mobileNumber?: InputMaybe<InputVisitorField>;
  visiting?: InputMaybe<InputVisitorField>;
};

export type InputVisitorPolicy = {
  autoCancelDeskBookingsWhenDailyPassFailed?: InputMaybe<Scalars['Boolean']['input']>;
  dailyPass?: InputMaybe<InputVisitorDailyPass>;
  enableVisitorPicture?: InputMaybe<Scalars['Boolean']['input']>;
  registrationNotifyVisitor?: InputMaybe<Scalars['Boolean']['input']>;
  requireDailyPass?: InputMaybe<Scalars['Boolean']['input']>;
  requireVisitorPicture?: InputMaybe<Scalars['Boolean']['input']>;
  visitorFields?: InputMaybe<InputVisitorFields>;
  visitorSignInNotifyHost?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputWidget = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<WidgetCategory>;
  floorId?: InputMaybe<Scalars['ID']['input']>;
  lngLat?: InputMaybe<InputSpaceLngLat>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  showData?: InputMaybe<Scalars['Boolean']['input']>;
  showStatusIcon?: InputMaybe<Scalars['Boolean']['input']>;
  space?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<WidgetType>;
};

export type InputZone = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<InputAmenity>>>;
  approvalsRequired: Scalars['Boolean']['input'];
  assignedGroups?: InputMaybe<Array<InputMaybe<InputSpaceAssignedGroup>>>;
  assignedUsers?: InputMaybe<Array<InputMaybe<InputSpaceAssignedUser>>>;
  bookable: Scalars['Boolean']['input'];
  bookingSlots?: InputMaybe<InputBookingSlotTemplate>;
  bookingType: Scalars['String']['input'];
  capacity: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  floorId: Scalars['String']['input'];
  floorPlanId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export enum InsightType {
  Location = 'location',
  Space = 'space'
}

export type Integration = {
  __typename?: 'Integration';
  _id?: Maybe<Scalars['String']['output']>;
  allowMultiple?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  configurations?: Maybe<Array<Maybe<ConfiguredIntegration>>>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<IntegrationImage>;
  interestLink?: Maybe<Scalars['String']['output']>;
  learnMoreLink?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<IntegrationOptions>>>;
};

export type IntegrationImage = {
  __typename?: 'IntegrationImage';
  feature?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  logotype?: Maybe<Scalars['String']['output']>;
};

export type IntegrationOptions = {
  __typename?: 'IntegrationOptions';
  fieldType?: Maybe<Scalars['String']['output']>;
  help?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IotDevice = {
  __typename?: 'IotDevice';
  _id: Scalars['ID']['output'];
  createdBy?: Maybe<IotCreateData>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<IotCreateData>;
  deviceId?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<IotCreateData>;
};

export enum Job_Category {
  Access = 'access',
  Booking = 'booking',
  Catering = 'catering',
  Equipment = 'equipment',
  Layout = 'layout',
  Support = 'support'
}

export enum Job_Item_Type {
  Automated = 'automated',
  Manual = 'manual'
}

export enum Job_Priority {
  High = 'high',
  Highest = 'highest',
  Low = 'low',
  Lowest = 'lowest',
  Normal = 'normal'
}

export enum Job_Status {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Complete = 'complete',
  Error = 'error',
  InProgress = 'in_progress',
  NotCreated = 'not_created',
  ToDo = 'to_do'
}

/** A list of tasks that needs to be completed. Jobs are children of a request */
export type Job = {
  __typename?: 'Job';
  _id?: Maybe<Scalars['ID']['output']>;
  assignedTo?: Maybe<Employee>;
  boardOrder?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<JobComment>;
  completedDate?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  deliveryTime?: Maybe<Scalars['Date']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  friendlyId?: Maybe<Scalars['String']['output']>;
  jobCategory?: Maybe<Job_Category>;
  jobItems?: Maybe<Array<Maybe<RequestedJobItem>>>;
  lastUpdatedDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Job_Priority>;
  requestId?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<Employee>;
  requestedDate?: Maybe<Scalars['String']['output']>;
  space?: Maybe<Space>;
  status?: Maybe<Job_Status>;
};

export type JobComment = {
  __typename?: 'JobComment';
  author?: Maybe<Employee>;
  text?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export type JobCommentInput = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type JobInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  boardOrder?: InputMaybe<Scalars['Int']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  jobCategory?: InputMaybe<Job_Category>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Job_Priority>;
  status?: InputMaybe<Update_Job_Status>;
};

/** An individual item that can be requested as part of a request */
export type JobItem = {
  __typename?: 'JobItem';
  _id: Scalars['ID']['output'];
  allergens?: Maybe<Array<Maybe<Allergen>>>;
  approvalGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  approvalIndividuals?: Maybe<Array<Maybe<Employee>>>;
  assetId?: Maybe<Scalars['String']['output']>;
  availableLocations?: Maybe<Array<Maybe<Location>>>;
  availableSpaces?: Maybe<Array<Maybe<Space>>>;
  /** Only valid if the job is a layout */
  capacity?: Maybe<Scalars['Int']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['ID']['output'];
  cutOffMinutes?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  jobCategory?: Maybe<Scalars['String']['output']>;
  jobItemType?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** If the job item is for a layout, this will be populated with the [SpaceLayout] */
  layout?: Maybe<SpaceLayout>;
  limit?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<Maybe<JobQuestion>>>;
  resetMinutes?: Maybe<Scalars['Int']['output']>;
  setupMinutes?: Maybe<Scalars['Int']['output']>;
};

export type JobItemInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  allergens?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvalGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvalIndividuals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assetId?: InputMaybe<Scalars['String']['input']>;
  availableLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableSpaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cost?: InputMaybe<Scalars['String']['input']>;
  cutOffMinutes?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  jobCategory?: InputMaybe<Job_Category>;
  jobItemCategory?: InputMaybe<Scalars['String']['input']>;
  jobItemType?: InputMaybe<Job_Item_Type>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  layouts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<InputMaybe<JobQuestionInput>>>;
  resetMinutes?: InputMaybe<Scalars['Int']['input']>;
  setupMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type JobMetadataInput = {
  comment?: InputMaybe<JobCommentInput>;
  deliveryTime?: InputMaybe<Scalars['Date']['input']>;
  jobCategory?: InputMaybe<Job_Category>;
};

export type JobQuestion = {
  __typename?: 'JobQuestion';
  fieldType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type JobQuestionAnswer = {
  __typename?: 'JobQuestionAnswer';
  number?: Maybe<Scalars['Int']['output']>;
  userValue?: Maybe<Scalars['String']['output']>;
};

export type JobQuestionInput = {
  fieldType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** To request a job item as part of a request */
export type JobRequest = {
  __typename?: 'JobRequest';
  jobItemId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  questionAnswers?: Maybe<Array<Maybe<JobQuestionAnswer>>>;
  userValue?: Maybe<Scalars['String']['output']>;
};

export enum LabFeature {
  Chatbot = 'Chatbot',
  CompanyNews = 'CompanyNews',
  ExperimentalMapRenderer = 'ExperimentalMapRenderer',
  FeedEnhancements = 'FeedEnhancements',
  InOfficeStatus = 'InOfficeStatus',
  InOfficeStatusQrScanning = 'InOfficeStatusQRScanning',
  MapPoisAndWidgets = 'MapPoisAndWidgets',
  MobileInsights = 'MobileInsights',
  OpenLockerCell = 'OpenLockerCell',
  SpaceReviews = 'SpaceReviews'
}

export type LabFeatures = {
  __typename?: 'LabFeatures';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  feature?: Maybe<LabFeature>;
};

export type LabFeaturesInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feature?: InputMaybe<LabFeature>;
};

export type Labs = {
  __typename?: 'Labs';
  /** @deprecated Use labFeatures instead */
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  labFeatures?: Maybe<Array<Maybe<LabFeatures>>>;
  nextUser?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A location object. This includes key information such as the timezoneID and locations office hours which are used for booking workspaces.
 * It also includes name, address and image information
 */
export type Location = CoreDoc & {
  __typename?: 'Location';
  _id: Scalars['ID']['output'];
  address?: Maybe<LocationAddress>;
  capacity?: Maybe<LocationCapacity>;
  createdBy?: Maybe<CreateData>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A resolver for floors that are associated to the location.
   * The location floors aren't stored on the location
   */
  floors?: Maybe<Array<Maybe<Floor>>>;
  googleBuildingId?: Maybe<Scalars['String']['output']>;
  hasAdvancedMap?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  locationCode?: Maybe<Scalars['String']['output']>;
  mapImage?: Maybe<Scalars['String']['output']>;
  mapwizeId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  o365Integration?: Maybe<Scalars['String']['output']>;
  officeHours?: Maybe<Array<Maybe<OfficeHour>>>;
  outlookRoomAddress?: Maybe<Scalars['String']['output']>;
  /**
   * A resolver for the location policy.
   * The location policy isn't stored on the location.
   */
  policy?: Maybe<Policy>;
  /**
   * A resolver to return the configured space labels for a location
   * The space labels isn't stored on the location directly
   */
  spaceLabels?: Maybe<Array<Maybe<SpaceLabel>>>;
  /**
   * A resolver for spaces that are associated to the location.
   * The location spaces aren't stored on the location.
   * An optional floorId and spaceType can be provided to filter the spaces list further
   */
  spaces?: Maybe<Array<Maybe<Space>>>;
  /** High level stats about the location. This includes spaces and floor numbers */
  stats?: Maybe<LocationStats>;
  timezone?: Maybe<Timezone>;
  timezoneId?: Maybe<Scalars['String']['output']>;
  tzTimezone?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
  venueGroup?: Maybe<VenueGroup>;
  visitor?: Maybe<VisitorConfig>;
};


/**
 * A location object. This includes key information such as the timezoneID and locations office hours which are used for booking workspaces.
 * It also includes name, address and image information
 */
export type LocationSpacesArgs = {
  floorId?: InputMaybe<Scalars['ID']['input']>;
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LocationAddress = {
  __typename?: 'LocationAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated Snake case is invalid. Use `formattedAddress`. */
  formatted_address?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mapsUrl?: Maybe<Scalars['String']['output']>;
  plusCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Snake case is invalid. Use `plusCode`. */
  plus_Code?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
};

export type LocationCapacity = {
  __typename?: 'LocationCapacity';
  designedCapacity?: Maybe<Scalars['Int']['output']>;
  maxCapacity?: Maybe<Scalars['Int']['output']>;
  targetCapacity?: Maybe<Scalars['Int']['output']>;
};

export type LocationStats = {
  __typename?: 'LocationStats';
  allDesks?: Maybe<Scalars['Int']['output']>;
  availableDesks?: Maybe<Scalars['Int']['output']>;
  floors?: Maybe<Scalars['Int']['output']>;
  parking?: Maybe<Scalars['Int']['output']>;
  rooms?: Maybe<Scalars['Int']['output']>;
  zones?: Maybe<Scalars['Int']['output']>;
};

export type LoginMethod = {
  __typename?: 'LoginMethod';
  id?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<LoginMethodOption>>>;
};

export type LoginMethodOption = {
  __typename?: 'LoginMethodOption';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Measure = {
  __typename?: 'Measure';
  backgroundColour?: Maybe<Scalars['String']['output']>;
  darkBackgroundColour?: Maybe<Scalars['String']['output']>;
  darkTextColour?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  measurement?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rag?: Maybe<Scalars['String']['output']>;
  textColour?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['Date']['output']>;
};

export type MeetingRoomPolicy = {
  __typename?: 'MeetingRoomPolicy';
  allowCancelFromPanel?: Maybe<Scalars['Boolean']['output']>;
  allowEarlyCheckOutFromPanel?: Maybe<Scalars['Boolean']['output']>;
  maxRecurringInstances?: Maybe<Scalars['Int']['output']>;
  minutesAfterCheckIn?: Maybe<Scalars['Int']['output']>;
  minutesBeforeCheckIn?: Maybe<Scalars['Int']['output']>;
  requireCheckIn?: Maybe<Scalars['Boolean']['output']>;
};

export type MessageTokenResult = {
  __typename?: 'MessageTokenResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type MicrosoftAdGroup = {
  __typename?: 'MicrosoftAdGroup';
  assigned?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  synced?: Maybe<Scalars['Boolean']['output']>;
};

export type MicrosoftNotificationDecryptedContent = {
  __typename?: 'MicrosoftNotificationDecryptedContent';
  createdDateTime?: Maybe<Scalars['String']['output']>;
  end?: Maybe<MicrosoftNotificationTime>;
  eventId?: Maybe<Scalars['String']['output']>;
  iCalUId?: Maybe<Scalars['String']['output']>;
  isAllDay?: Maybe<Scalars['Boolean']['output']>;
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedDateTime?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<MicrosoftNotificationOrganizer>;
  seriesMasterId?: Maybe<Scalars['String']['output']>;
  start?: Maybe<MicrosoftNotificationTime>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftNotificationOrganizer = {
  __typename?: 'MicrosoftNotificationOrganizer';
  emailAddress?: Maybe<NotificationEmailAddress>;
};

export type MicrosoftNotificationTime = {
  __typename?: 'MicrosoftNotificationTime';
  dateTime?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftWatcherNotification = {
  __typename?: 'MicrosoftWatcherNotification';
  _id?: Maybe<Scalars['ID']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  decryptedContents?: Maybe<MicrosoftNotificationDecryptedContent>;
  floorId?: Maybe<Scalars['ID']['output']>;
  isBookingCreated?: Maybe<Scalars['Boolean']['output']>;
  processed?: Maybe<Scalars['Boolean']['output']>;
  processedDate?: Maybe<Scalars['Date']['output']>;
  spaceId?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Array<Maybe<MicrosoftWatcherValue>>>;
};

export type MicrosoftWatcherValue = {
  __typename?: 'MicrosoftWatcherValue';
  changeType: Scalars['String']['output'];
  clientState: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  subscriptionExpirationDateTime: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addBadgetoUser?: Maybe<Employee>;
  addSpaceLayout?: Maybe<JobItem>;
  /**
   * Updates an existing visits checkInStatus.
   * To be used by admins with auth privileges
   */
  adminUpdateVisitCheckInStatus?: Maybe<Visit>;
  /**
   * Updates an existing visits checkInStatus.
   * To be used by admins with auth privileges
   */
  adminUpdateVisitSignInStatus?: Maybe<Visit>;
  /** Anonymise visits for all customers where the anonymisation date is passed the locations configured policy */
  anonymiseVisits?: Maybe<Scalars['Boolean']['output']>;
  assignJob?: Maybe<Job>;
  /** A query to the assistant */
  assistant?: Maybe<AssistantResponse>;
  /** @deprecated autoCancelBooking should no longer be used, instead use cancelScreenBooking */
  autoCancelBooking?: Maybe<Scalars['Boolean']['output']>;
  /** Given a list of valid space ids set the deleted flag to true */
  bulkCreateSpacesFromFloorplan?: Maybe<Scalars['Boolean']['output']>;
  /** Given a list of valid ids set the deleted flag to true */
  bulkDeleteEmployees?: Maybe<Scalars['Boolean']['output']>;
  /** Given a list of valid space ids set the deleted flag to true */
  bulkDeleteSpaces?: Maybe<Scalars['Boolean']['output']>;
  /** Given valid visitorIds set deleted flag to true */
  bulkDeleteVisitors?: Maybe<Scalars['Boolean']['output']>;
  /** Given a list of valid ids set the isDisabled flag to true */
  bulkDisableEmployees?: Maybe<Scalars['Boolean']['output']>;
  /** Given a list of valid  ids and bulk update showAsHostOnVisitorApp value to true */
  bulkUpdateHosts?: Maybe<Scalars['Boolean']['output']>;
  /** Given a list of valid space ids and bulk update values, update the spaces from the list of ids with the updated values */
  bulkUpdateSpaces?: Maybe<Scalars['Boolean']['output']>;
  /** Given a list of valid InputEmployees bulk create / update employee records depending on if the email address already exists. */
  bulkUploadEmployees?: Maybe<Scalars['Boolean']['output']>;
  /** Bulk upload (create/update) AD groups */
  bulkUploadGroups?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Bulk upload visit from a CSV upload
   * This function also creates visitors associated to visits when the visitor can't be found by email
   * If the visitor first name and last name isn't provided during the create process, no visits will be created
   */
  bulkUploadVisitsFromCSV?: Maybe<Array<Maybe<Visit>>>;
  /** @deprecated cancelBooking should no longer be used, instead use cancelRoomBooking */
  cancelBooking?: Maybe<ScreenBooking>;
  /** Cancel a single booking */
  cancelCalendarBooking?: Maybe<CancelBookingResponse>;
  cancelNonCheckedIntoBookings?: Maybe<Scalars['Boolean']['output']>;
  cancelOrEndRoomBookingFromQR?: Maybe<ScreenBooking>;
  cancelRoomBooking?: Maybe<ScreenBooking>;
  cancelScreenBooking?: Maybe<Scalars['Boolean']['output']>;
  cancelScreenBookingWarning?: Maybe<Scalars['Boolean']['output']>;
  /** Cancel a parking booking on Toogethr */
  cancelToogethrParkingBooking?: Maybe<Scalars['Boolean']['output']>;
  checkInOutBooking?: Maybe<ScreenBooking>;
  /** @deprecated checkInOutRoomBooking should no longer be used, instead use checkInOutBooking */
  checkInOutRoomBooking?: Maybe<ScreenBooking>;
  /** Check into a workspace booking, i.e. desk booking, or in office status */
  checkInOutWorkspaceBooking?: Maybe<ScreenBooking>;
  /**
   * Check into a booking of any type.
   * An admin user can check into another users booking.
   * If a space is being attached to the booking (on arrival zone booking) it can be provided
   * If you're checking into a meeting room booking, a iCalUId and organisersEmail and timezone  should be provided
   */
  checkIntoBooking?: Maybe<Booking>;
  /**
   * Check into a booking of any type.
   * An admin user can check into another users booking.
   * If you're checking into a meeting room booking, a iCalUId and organisersEmail and timezone should be provided
   */
  checkOutBooking?: Maybe<Booking>;
  clearJobs?: Maybe<ClearJobsResponse>;
  /** Pair a new display or update an exiting connection */
  connectScreen?: Maybe<Screen>;
  /** Create a single booking of any type.s */
  createBooking?: Maybe<CreateBookingResponse>;
  createBookingFromQR?: Maybe<ScreenBooking>;
  createBookingFromScreen?: Maybe<ScreenBooking>;
  /**
   * Given a list of bookings, validate and create them
   * Send an email on successfully created bookings
   * Only supports desk, parking and locker booking.
   * For room bookings use createBooking.
   * For office booking use createWorkspaceBooking.
   */
  createBookings?: Maybe<Array<Maybe<Booking>>>;
  createBookingsFromScreen?: Maybe<Array<Maybe<Booking>>>;
  /**
   * Create a customer.
   * This action can only happen by super admins
   */
  createCustomer?: Maybe<Customer>;
  /**
   * Give a user who's not got access to any other customers, customer access.
   * This can only be executed by super admins
   */
  createCustomerAccess?: Maybe<CustomerAccess>;
  /** Create a dailyPass for a  visit. */
  createDailyPass?: Maybe<DailyPass>;
  /** create emergency list of visitors on site during emergency */
  createEmergencyList?: Maybe<EmergencyList>;
  /** Create daily pass */
  createEmployeeDailyPass?: Maybe<DailyPass>;
  /**
   * Create a new floor.
   * This is only possible by a user with an admin role
   */
  createFloor?: Maybe<Floor>;
  /** Create a single group */
  createGroup?: Maybe<Group>;
  /** Create a single integration configuration */
  createIntegration?: Maybe<ConfiguredIntegration>;
  /** Create a new Job Item that can be requested */
  createJobItem?: Maybe<JobItem>;
  /**
   * Create a new location.
   * This is only possible by a user with an admin role
   */
  createLocation?: Maybe<Location>;
  /** Create request */
  createRequest?: Maybe<CreateRequestResponse>;
  /** Create a new orphan screen (no edit permissions) in mongo */
  createScreen?: Maybe<IdToken>;
  createScreenWorkspaceBooking?: Maybe<ScreenBooking>;
  /**
   * Create a new space.
   * This is only possible by a user with an admin role
   */
  createSpace?: Maybe<Space>;
  /**
   * Create a new spaceLabel.
   * This is only possible by a user with an admin role
   */
  createSpaceLabel?: Maybe<SpaceLabel>;
  /**
   * Create a new space layout.
   * This is only possible by a user with an admin role
   */
  createSpaceLayout?: Maybe<SpaceLayout>;
  /** Create a parking booking on Toogethr */
  createToogethrParkingBooking?: Maybe<ToogethrBooking>;
  /**
   * Create user status, a statusID and date are required to create a status.
   * Returned is the newly created user status.
   */
  createUserStatus?: Maybe<UserStatus>;
  /** Create a single vehicle */
  createVehicle?: Maybe<Vehicle>;
  /**
   * Create a new visit.
   * This is only possible by a user with an admin role
   * @deprecated Use createVisits instead
   */
  createVisit?: Maybe<Visit>;
  /**
   * Create a new visit.
   * This is only possible by a user with an admin role
   */
  createVisitForSelf?: Maybe<Visit>;
  /**
   * Create a new visitor.
   * This is only possible by a user with an admin role
   */
  createVisitor?: Maybe<Visitor>;
  /**
   * Create new visitors.
   * This is only possible by a user with an admin role
   */
  createVisitors?: Maybe<Array<Maybe<Visitor>>>;
  /**
   * Create a multiple new visit.
   * This is only possible by a user with an admin role
   */
  createVisits?: Maybe<Visit>;
  /**
   * Create a multiple new visit.
   * This is only possible by a user with an admin role
   */
  createVisitsForSelf?: Maybe<Visit>;
  /**
   * Creates a space watcher against the calendar provider.
   * If a watcher already exists nothing will occure.
   */
  createWatcher?: Maybe<SpaceWatcher>;
  /** Create a widget that will display on the map and show occupancy or environmental data */
  createWidget?: Maybe<Widget>;
  /**
   * Given a location or space or zone and booking slot, validate and create booking
   * If the user has already booked a workplace, it is canceled
   * Only supports desk, zone and location.
   * To book a zone, zone.bookingType should be deskOnArrival or bookingAndArrival
   */
  createWorkspaceBooking?: Maybe<Array<Maybe<Booking>>>;
  /**
   * Ability to tag a customer as deleted
   * this action can only be carried out by super admins
   * the deletion is a soft delete only
   */
  deleteCustomer?: Maybe<Customer>;
  /** Delete a dailyPass for a visit. */
  deleteDailyPass?: Maybe<DailyPass>;
  /** delete existing emergency list of visitors on site during emergency */
  deleteEmergencyList?: Maybe<EmergencyList>;
  /** Delete daily pass */
  deleteEmployeeDailyPass?: Maybe<DailyPass>;
  /** Given a valid floorId set the deleted flag to true d */
  deleteFloor?: Maybe<Floor>;
  /** Remove all global roles assigned to a specific user */
  deleteGlobalUserRoles?: Maybe<User>;
  /** Given a valid group _id set the deleted flag to true */
  deleteGroup?: Maybe<Group>;
  /**
   * Delete a single integration configuration,
   * this requires the integration id as part of the ConfiguredIntegrationInput property
   */
  deleteIntegration?: Maybe<ConfiguredIntegration>;
  /** Delete a job item */
  deleteJobItem?: Maybe<JobItem>;
  /** Remove all local roles assigned to a specific user */
  deleteLocalUserRoles?: Maybe<User>;
  /** Given a valid locationId set the deleted flag to true */
  deleteLocation?: Maybe<Location>;
  /** Deletes a message token used for push notifications */
  deleteMessageToken?: Maybe<MessageTokenResult>;
  /** Delete an existing screen connection */
  deleteScreen?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Delete an existing space.
   * This is only possible by a user with an admin role
   */
  deleteSpace?: Maybe<Space>;
  /** Given a valid spaceLabelId set the deleted flag to true */
  deleteSpaceLabel?: Maybe<SpaceLabel>;
  /** Given a valid space layout _id set the deleted flag to true */
  deleteSpaceLayout?: Maybe<SpaceLayout>;
  /** Given a valid vehicle _id set the deleted flag to true */
  deleteVehicle?: Maybe<Vehicle>;
  /** Given a valid visitId set the deleted flag to true */
  deleteVisit?: Maybe<Visit>;
  /** Given a valid visitorId set the deleted flag to true */
  deleteVisitor?: Maybe<Visitor>;
  /** Given a valid visitId set the deleted flag to true */
  deleteVisits?: Maybe<Array<Maybe<Visit>>>;
  /** Given a valid zoneId set the deleted flag to true */
  deleteZone?: Maybe<Space>;
  /** Change booking end time to now */
  endBookingEarly?: Maybe<Booking>;
  endRoomBookingNow?: Maybe<ScreenBooking>;
  /**
   * Provide feedback to the assistant
   * Within the feedback only the response is required
   */
  feedbackChat?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Updates an existing location, generating a locationCode
   * This is only possible by a user with an admin role
   */
  generateLocationCode?: Maybe<Location>;
  /**
   * Generate a pin code for a visitor.
   * This is only possible by a user with an admin role
   */
  generatePinForVisitor?: Maybe<Visitor>;
  /** Get a list of login methods and basic customer information */
  getLoginMethods?: Maybe<PublicCustomer>;
  /** Request a magic link email & code */
  getMagicLink?: Maybe<Scalars['Boolean']['output']>;
  /** Hides booking from feed */
  hideBookingFromFeed?: Maybe<Booking>;
  /** Exchange a screens refresh token for a new Spaces token */
  issueNewScreenToken?: Maybe<IdToken>;
  /** Exchange a refresh token for a new Spaces token */
  issueNewToken?: Maybe<IdToken>;
  /** Temp - will be removed */
  loginWithAccessCode?: Maybe<IdToken>;
  /** Exchange an authenticated Google user token for a Spaces token */
  loginWithGoogleToken?: Maybe<IdToken>;
  /** Exchange an authenticated Microsoft  user token from Outlook Addin for a Spaces token */
  loginWithMicrosoftAddinToken?: Maybe<IdToken>;
  /** Exchange an authenticated Microsoft user token for a Spaces token */
  loginWithMicrosoftToken?: Maybe<IdToken>;
  /** Exchange an OKTA token for a Spaces Token */
  loginWithOktaToken?: Maybe<IdToken>;
  /** Attempt to open a cell of a locker */
  openLockerCell?: Maybe<Scalars['Boolean']['output']>;
  /** Automatically cancels desk bookings that have expired for the logged in customerId */
  processAutoCancelDeskBookings?: Maybe<Scalars['Boolean']['output']>;
  /** Automatically cancels room bookings that have expired for the logged in customerId */
  processAutoCancelRoomBookings?: Maybe<Scalars['Boolean']['output']>;
  /** Automatically cancels unnocupied desk bookings */
  processAutoCancelUnnocupiedDesks?: Maybe<Scalars['Boolean']['output']>;
  /** Automatically cancels zombie meetings */
  processAutoCancelZombieMeetings?: Maybe<Scalars['Boolean']['output']>;
  /** Sends booking reminder emails for the logged in customerId */
  processBookingReminders?: Maybe<Scalars['Boolean']['output']>;
  /** Sends reminders to users who have not completed their daily passes */
  processDailyPassReminders?: Maybe<Scalars['Boolean']['output']>;
  /** Anonymises desk booking information when the locations policy has desk anonymisation set to true */
  processDeskBookingAnonymisation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Given a date and location, quick book a desk for the current user
   * based on their favourites or recently booked desks
   */
  quickBookForDate?: Maybe<Array<Maybe<Booking>>>;
  /** Set all unread notifications to be read for the current user */
  readAllNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** Set a single notification to read for the current user */
  readNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Complete registration process for a visit. */
  registerVisit?: Maybe<Visit>;
  /** Release a single booking by its ID */
  releaseBooking?: Maybe<Booking>;
  /** Release a workspace booking by ID */
  releaseWorkspaceBooking?: Maybe<Booking>;
  removeSpaceLayout?: Maybe<JobItem>;
  /**
   * Remove a user status, the ID of the user status is required.
   * A boolean is return
   */
  removeUserStatus?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Removes a visitor from list of attendees on a booking
   * This is only possible by a user with an admin role
   */
  removeVisitorAsAttendee?: Maybe<Booking>;
  /**
   * Ability to restore a previously deleted customer
   * this action can only be carried out by super admins
   */
  restoreCustomer?: Maybe<Customer>;
  /** Save a message token used for push notifications */
  saveMessageToken?: Maybe<MessageTokenResult>;
  saveScreenMessageToken?: Maybe<ScreenMessageTokenResult>;
  /** Save a users space review for a specific space */
  saveSpaceReview?: Maybe<UserSpaceReview>;
  /** Send push notifications to a list of customers */
  sendPushNotifications?: Maybe<PushNotificationsResult>;
  /** Send push notifications to a list of screens */
  sendScreenPushNotifications?: Maybe<PushNotificationsResult>;
  /** Sends daily pass email to visitor */
  sendVisitorDailyPassEmail?: Maybe<Scalars['Boolean']['output']>;
  setSpaceApproval?: Maybe<JobItem>;
  /**
   * Switch to another customer and get an updated ID Token
   * An optional MS token can be provided which will enable getting the users tenant for use elsewhere around the app
   */
  switchCustomer?: Maybe<IdToken>;
  /**
   * Sync all AD Groups for a specific customer
   * Action can only be performed by an Admin
   */
  syncADGroups?: Maybe<Scalars['Boolean']['output']>;
  /** A test function for syncing room bookings */
  syncRoomBookings?: Maybe<Scalars['Boolean']['output']>;
  /** Test if application has connection to graph */
  testConnection?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Toggle on and off whether a space is a favourite or not.
   * Provide a required spaceId and a required isFavourite boolean
   *
   * If isFavourite is set to true the space will be added to the fav space list
   * If isFavourite is set to false the space will be removed from the fav space list
   */
  toggleFavouriteSpace?: Maybe<Scalars['Boolean']['output']>;
  /** Update a single booking of any type. */
  updateBooking?: Maybe<CreateBookingResponse>;
  /** Update a single booking status of any type. */
  updateCalendarBookingStatus?: Maybe<UpdateBookingStatusResponse>;
  /**
   * Update the customer.
   * This action can only happen by super admins
   */
  updateCustomer?: Maybe<Customer>;
  /**
   * A user who already has customer access can be given access to more or less customers via this process
   * This can only be executed by super admins
   */
  updateCustomerAccess?: Maybe<CustomerAccess>;
  /** update existing emergency list of visitors on site during emergency */
  updateEmergencyList?: Maybe<EmergencyList>;
  /**
   * Update a single employee with all the employee data
   * This should be used by admins only
   */
  updateEmployee?: Maybe<Employee>;
  /**
   * Updated an existing floor.
   * This is only possible by a user with an admin role
   */
  updateFloor?: Maybe<Floor>;
  /** Given a list of floors and their orders, update the floor with the new order. */
  updateFloorsOrder?: Maybe<Array<Maybe<Floor>>>;
  /** Update a single group */
  updateGroup?: Maybe<Group>;
  /**
   * Update group members. Arrays of members added and members removed should be provided.
   * If no members are added or removed an empty array should still be provided.
   */
  updateGroupMembers?: Maybe<Array<Maybe<Employee>>>;
  /**
   * Update a single integration configuration,
   * this requires the integration id as part of the ConfiguredIntegrationInput property
   */
  updateIntegration?: Maybe<ConfiguredIntegration>;
  updateJob?: Maybe<Job>;
  updateJobInfo?: Maybe<Job>;
  /** Update Job Item */
  updateJobItem?: Maybe<JobItem>;
  /**
   * Updated an existing location.
   * This is only possible by a user with an admin role
   */
  updateLocation?: Maybe<Location>;
  /**
   * Update the properties of a specific locations policy
   * The entire policy should be provided during the update
   */
  updateLocationPolicy?: Maybe<Policy>;
  /**
   * Update venue groups for locations. Passing oldVenueGroupName will remove venue groups with that name.
   * Passing venueGroupName and locationIds will add venue groups to the specified locations
   */
  updateLocationVenueGroups?: Maybe<Scalars['Boolean']['output']>;
  /** Update the current users loop members */
  updateLoopMembers?: Maybe<Group>;
  /**
   * Update a single employee with all the employee data
   * This should be used by the current user to update their own profiles
   */
  updateProfile?: Maybe<Employee>;
  /**
   * Update the public customer.
   * Its only possible to update the customers name, image, description and primary color.
   * All other properties should be updated elsewhere
   */
  updatePublicCustomer?: Maybe<PublicCustomer>;
  updateRequest?: Maybe<CreateRequestResponse>;
  /** update an existing screen connection */
  updateScreen?: Maybe<Screen>;
  /**
   * Update an existing space.
   * This is only possible by a user with an admin role
   */
  updateSpace?: Maybe<Space>;
  /**
   * Updated an existing spaceLabel.
   * This is only possible by a user with an admin role
   */
  updateSpaceLabel?: Maybe<SpaceLabel>;
  /**
   * Updates an existing space layout.
   * This is only possible by a user with an admin role
   */
  updateSpaceLayout?: Maybe<SpaceLayout>;
  updateUserLabFeatures?: Maybe<Array<Maybe<LabFeatures>>>;
  /**
   * Update an existing user status, an ID, statusID and date are required to create a status.
   * Returned is the updated user status.
   */
  updateUserStatus?: Maybe<UserStatus>;
  /** Update a single vehicle */
  updateVehicle?: Maybe<Vehicle>;
  /**
   * Updates an existing visit.
   * This is only possible by a user with an admin role
   */
  updateVisit?: Maybe<Visit>;
  /**
   * Updates an existing visits checkInStatus.
   * To be used by visitors without auth privileges
   */
  updateVisitCheckInStatus?: Maybe<Visit>;
  /** update registered visit for registration process. */
  updateVisitRegistration?: Maybe<Visit>;
  /** Updates an existing visits checkInStatus. */
  updateVisitSignInStatus?: Maybe<Visit>;
  /**
   * Updates an existing visitor.
   * This is only possible by a user with an admin role
   */
  updateVisitor?: Maybe<Visitor>;
  /** Update a widget that will display on the map and show occupancy or environmental data */
  updateWidget?: Maybe<Widget>;
  /**
   * Creates or updates a customMessage based on if one of the same type already exists.
   * This is only possible by a user with an admin role
   */
  upsertCustomMessage?: Maybe<CustomMessage>;
  /**
   * Create or update an array of roles to a single user
   * The roles can only be global
   * Any local roles attempted to be added will be ignored
   */
  upsertGlobalUserRoles?: Maybe<User>;
  /**
   * Upsert a iot device.
   * This is only possible by a user with an admin role
   */
  upsertIotDevice?: Maybe<IotDevice>;
  /**
   * Create or update an array of roles to a single user
   * The roles can only be local
   * Any global roles attempted to be added will be ignored
   */
  upsertLocalUserRoles?: Maybe<User>;
  /**
   * When the user doesn't existing but we still want to associate roles to them
   * Call this endpoint. It will create a new User and Create roles against them.
   */
  upsertNewUserWithUserRoles?: Maybe<User>;
  validateBadgePairingRequest?: Maybe<Employee>;
  /** Validate the magic link code */
  validateMagicLink?: Maybe<IdToken>;
};


export type MutationAddBadgetoUserArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddSpaceLayoutArgs = {
  update: SpaceLayoutInput;
};


export type MutationAdminUpdateVisitCheckInStatusArgs = {
  method: SignInMethod;
  timezone: Scalars['String']['input'];
  visitId: Scalars['ID']['input'];
};


export type MutationAdminUpdateVisitSignInStatusArgs = {
  method: SignInMethod;
  resetStatus?: InputMaybe<Scalars['Boolean']['input']>;
  timezone: Scalars['String']['input'];
  visitId: Scalars['ID']['input'];
};


export type MutationAssignJobArgs = {
  update: AssignJobInput;
};


export type MutationAssistantArgs = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};


export type MutationAutoCancelBookingArgs = {
  bookedByEmail: Scalars['String']['input'];
  bookingId?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationBulkCreateSpacesFromFloorplanArgs = {
  spaceDetails: InputBulkCreateSpaceFromFloorplan;
};


export type MutationBulkDeleteEmployeesArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationBulkDeleteSpacesArgs = {
  spaceIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationBulkDeleteVisitorsArgs = {
  visitorIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationBulkDisableEmployeesArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationBulkUpdateHostsArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationBulkUpdateSpacesArgs = {
  bulkUpdateDetails?: InputMaybe<InputBulkSpaceUpdate>;
};


export type MutationBulkUploadEmployeesArgs = {
  employees: Array<InputMaybe<EmployeeInput>>;
};


export type MutationBulkUploadGroupsArgs = {
  groups: Array<InputMaybe<InputGroup>>;
};


export type MutationBulkUploadVisitsFromCsvArgs = {
  locationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  visits: Array<InputMaybe<InputCsvVisit>>;
};


export type MutationCancelBookingArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  bookerEmail?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['String']['input']>;
  cancelRecurrence?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelCalendarBookingArgs = {
  bookerEmail?: InputMaybe<Scalars['String']['input']>;
  cancelRecurrence?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  userCalendarToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelOrEndRoomBookingFromQrArgs = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  iCalUid?: InputMaybe<Scalars['String']['input']>;
  isEndNow?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  screenId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userCalendarToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelRoomBookingArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  bookerEmail?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['String']['input']>;
  cancelRecurrence?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelScreenBookingArgs = {
  customerId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationCancelScreenBookingWarningArgs = {
  customerId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationCancelToogethrParkingBookingArgs = {
  toogethrId: Scalars['String']['input'];
};


export type MutationCheckInOutBookingArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  bookerEmail?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  isCheckOut: Scalars['Boolean']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCheckInOutRoomBookingArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  bookerEmail?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  isCheckOut: Scalars['Boolean']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCheckInOutWorkspaceBookingArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  bookingId: Scalars['String']['input'];
  isCheckOut: Scalars['Boolean']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCheckIntoBookingArgs = {
  checkInMethod: Scalars['String']['input'];
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organisersEmail?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCheckOutBookingArgs = {
  checkOutMethod?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organisersEmail?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClearJobsArgs = {
  jobIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationConnectScreenArgs = {
  screen: ConnectScreenInput;
};


export type MutationCreateBookingArgs = {
  booking: BookingInput;
  bookingMethod?: InputMaybe<BookingMethod>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<AvailabilityUser>;
  userCalendarToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBookingFromQrArgs = {
  endTime: Scalars['Date']['input'];
  screenId: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['Date']['input'];
  subject: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  userCalendarToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBookingFromScreenArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['Date']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['Date']['input'];
  subject: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationCreateBookingsArgs = {
  bookingMethod?: InputMaybe<BookingMethod>;
  bookings: Array<InputMaybe<BookingInput>>;
  sendEmailConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<AvailabilityUser>;
};


export type MutationCreateBookingsFromScreenArgs = {
  bookings?: InputMaybe<Array<InputMaybe<BookingInput>>>;
  date?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomerArgs = {
  customer: InputFullCustomer;
};


export type MutationCreateCustomerAccessArgs = {
  customerAccess: InputCustomerAccess;
};


export type MutationCreateDailyPassArgs = {
  customerId: Scalars['String']['input'];
  isValid: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  visit: InputVisit;
};


export type MutationCreateEmergencyListArgs = {
  locationId: Scalars['ID']['input'];
};


export type MutationCreateEmployeeDailyPassArgs = {
  date: Scalars['String']['input'];
  isValid: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationCreateFloorArgs = {
  floor?: InputMaybe<InputFloor>;
};


export type MutationCreateGroupArgs = {
  group: InputGroup;
};


export type MutationCreateIntegrationArgs = {
  integration: ConfiguredIntegrationInput;
};


export type MutationCreateJobItemArgs = {
  jobItem: JobItemInput;
};


export type MutationCreateLocationArgs = {
  location?: InputMaybe<InputLocation>;
};


export type MutationCreateRequestArgs = {
  request: CreateRequestInput;
};


export type MutationCreateScreenArgs = {
  locationCode: Scalars['String']['input'];
};


export type MutationCreateScreenWorkspaceBookingArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSpaceArgs = {
  space: InputSpace;
};


export type MutationCreateSpaceLabelArgs = {
  spaceLabel?: InputMaybe<InputSpaceLabel>;
};


export type MutationCreateSpaceLayoutArgs = {
  spaceLayout: InputSpaceLayout;
};


export type MutationCreateToogethrParkingBookingArgs = {
  bookedForId: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserStatusArgs = {
  status: InputUserStatus;
};


export type MutationCreateVehicleArgs = {
  vehicle: InputVehicle;
};


export type MutationCreateVisitArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  visit?: InputMaybe<InputVisit>;
};


export type MutationCreateVisitForSelfArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  visit?: InputMaybe<InputVisit>;
};


export type MutationCreateVisitorArgs = {
  visitor?: InputMaybe<InputVisitor>;
};


export type MutationCreateVisitorsArgs = {
  visitors: Array<InputMaybe<InputVisitor>>;
};


export type MutationCreateVisitsArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  visits?: InputMaybe<Array<InputMaybe<InputVisit>>>;
};


export type MutationCreateVisitsForSelfArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  visits?: InputMaybe<Array<InputMaybe<InputVisit>>>;
};


export type MutationCreateWatcherArgs = {
  provider: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};


export type MutationCreateWidgetArgs = {
  widget: InputWidget;
};


export type MutationCreateWorkspaceBookingArgs = {
  bookingMethod?: InputMaybe<BookingMethod>;
  date: Scalars['String']['input'];
  getDailyPass?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  slotId?: InputMaybe<Scalars['ID']['input']>;
  spaceId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationDeleteDailyPassArgs = {
  dailyPassId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};


export type MutationDeleteEmergencyListArgs = {
  emergencyListId: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeDailyPassArgs = {
  dailypassId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteFloorArgs = {
  floorId: Scalars['String']['input'];
};


export type MutationDeleteGlobalUserRolesArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteGroupArgs = {
  groupId: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationArgs = {
  integration: ConfiguredIntegrationInput;
};


export type MutationDeleteJobItemArgs = {
  jobItemId: Scalars['ID']['input'];
};


export type MutationDeleteLocalUserRolesArgs = {
  locationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteLocationArgs = {
  locationId: Scalars['String']['input'];
};


export type MutationDeleteMessageTokenArgs = {
  platform: Scalars['String']['input'];
};


export type MutationDeleteScreenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSpaceArgs = {
  spaceId: Scalars['String']['input'];
};


export type MutationDeleteSpaceLabelArgs = {
  spaceLabelId: Scalars['String']['input'];
};


export type MutationDeleteSpaceLayoutArgs = {
  spaceLayoutId: Scalars['ID']['input'];
};


export type MutationDeleteVehicleArgs = {
  vehicleId: Scalars['ID']['input'];
};


export type MutationDeleteVisitArgs = {
  visitId: Scalars['String']['input'];
};


export type MutationDeleteVisitorArgs = {
  visitorId: Scalars['String']['input'];
};


export type MutationDeleteVisitsArgs = {
  visitIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeleteZoneArgs = {
  zoneId: Scalars['String']['input'];
};


export type MutationEndBookingEarlyArgs = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userCalendarToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEndRoomBookingNowArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  bookerEmail?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFeedbackChatArgs = {
  chatId: Scalars['String']['input'];
  feedback: FeedbackResponseInput;
};


export type MutationGenerateLocationCodeArgs = {
  locationId: Scalars['String']['input'];
};


export type MutationGeneratePinForVisitorArgs = {
  visitorId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetLoginMethodsArgs = {
  email: Scalars['String']['input'];
};


export type MutationGetMagicLinkArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  env?: InputMaybe<Scalars['String']['input']>;
  ipAddress: Scalars['String']['input'];
};


export type MutationHideBookingFromFeedArgs = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIssueNewScreenTokenArgs = {
  refreshToken: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationIssueNewTokenArgs = {
  refreshToken: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationLoginWithAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationLoginWithGoogleTokenArgs = {
  accessCode: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginWithMicrosoftAddinTokenArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationLoginWithMicrosoftTokenArgs = {
  accessCode: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginWithOktaTokenArgs = {
  authToken: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};


export type MutationOpenLockerCellArgs = {
  spaceId: Scalars['String']['input'];
};


export type MutationQuickBookForDateArgs = {
  bookingMethod?: InputMaybe<BookingMethod>;
  date: Scalars['String']['input'];
  getDailyPass?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationReadNotificationArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationRegisterVisitArgs = {
  customerId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  visit: InputVisit;
  visitor: InputVisitor;
};


export type MutationReleaseBookingArgs = {
  id: Scalars['String']['input'];
  releaseSeries?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationReleaseWorkspaceBookingArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveSpaceLayoutArgs = {
  update: SpaceLayoutInput;
};


export type MutationRemoveUserStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveVisitorAsAttendeeArgs = {
  bookedForEmail?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  visitorEmail: Scalars['String']['input'];
};


export type MutationRestoreCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationSaveMessageTokenArgs = {
  platform: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveScreenMessageTokenArgs = {
  customerId: Scalars['String']['input'];
  screenToken: Scalars['String']['input'];
};


export type MutationSaveSpaceReviewArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  spaceId: Scalars['ID']['input'];
};


export type MutationSendPushNotificationsArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationSendScreenPushNotificationsArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  data?: InputMaybe<Array<InputMaybe<ScreenPushNotificationDataInput>>>;
  screenIds: Array<InputMaybe<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendVisitorDailyPassEmailArgs = {
  visitId: Scalars['ID']['input'];
};


export type MutationSetSpaceApprovalArgs = {
  update: SpaceApprovalInput;
};


export type MutationSwitchCustomerArgs = {
  currentSignInType: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleFavouriteSpaceArgs = {
  isFavourite: Scalars['Boolean']['input'];
  spaceId: Scalars['ID']['input'];
};


export type MutationUpdateBookingArgs = {
  booking: BookingInput;
  timezone?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<AvailabilityUser>;
  userCalendarToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCalendarBookingStatusArgs = {
  providerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userCalendarToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCustomerArgs = {
  customer: InputFullCustomer;
  customerId: Scalars['ID']['input'];
};


export type MutationUpdateCustomerAccessArgs = {
  customerAccess: InputCustomerAccess;
  customerAccessId: Scalars['ID']['input'];
};


export type MutationUpdateEmergencyListArgs = {
  emergencyList: InputEmergencyList;
};


export type MutationUpdateEmployeeArgs = {
  employee: EmployeeInput;
};


export type MutationUpdateFloorArgs = {
  floor?: InputMaybe<InputFloor>;
};


export type MutationUpdateFloorsOrderArgs = {
  floors: Array<InputMaybe<FloorOrderUpdate>>;
};


export type MutationUpdateGroupArgs = {
  group: InputGroup;
};


export type MutationUpdateGroupMembersArgs = {
  group: InputPartialGroup;
  updatedMembers: InputGroupMembersUpdate;
};


export type MutationUpdateIntegrationArgs = {
  integration: ConfiguredIntegrationInput;
};


export type MutationUpdateJobArgs = {
  update: UpdateJobInput;
};


export type MutationUpdateJobInfoArgs = {
  job: JobInput;
};


export type MutationUpdateJobItemArgs = {
  jobItem: JobItemInput;
};


export type MutationUpdateLocationArgs = {
  location?: InputMaybe<InputLocation>;
};


export type MutationUpdateLocationPolicyArgs = {
  policy: InputPolicy;
};


export type MutationUpdateLocationVenueGroupsArgs = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  oldVenueGroupName?: InputMaybe<Scalars['String']['input']>;
  venueGroupName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLoopMembersArgs = {
  loopMembers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateProfileArgs = {
  employee: EmployeeInput;
};


export type MutationUpdatePublicCustomerArgs = {
  customer: InputCustomer;
};


export type MutationUpdateRequestArgs = {
  timezone: Scalars['String']['input'];
  update: UpdateRequestInput;
};


export type MutationUpdateScreenArgs = {
  id: Scalars['ID']['input'];
  screen: ConnectScreenInput;
};


export type MutationUpdateSpaceArgs = {
  space: InputSpace;
};


export type MutationUpdateSpaceLabelArgs = {
  spaceLabel?: InputMaybe<InputSpaceLabel>;
};


export type MutationUpdateSpaceLayoutArgs = {
  spaceLayout: InputSpaceLayout;
};


export type MutationUpdateUserLabFeaturesArgs = {
  labFeatures: Array<InputMaybe<LabFeaturesInput>>;
};


export type MutationUpdateUserStatusArgs = {
  id: Scalars['ID']['input'];
  status: InputUserStatus;
};


export type MutationUpdateVehicleArgs = {
  vehicle: InputVehicle;
};


export type MutationUpdateVisitArgs = {
  visit?: InputMaybe<InputVisit>;
};


export type MutationUpdateVisitCheckInStatusArgs = {
  customerId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  method: SignInMethod;
  timezone: Scalars['String']['input'];
  visitId: Scalars['ID']['input'];
};


export type MutationUpdateVisitRegistrationArgs = {
  customerId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  visit: InputVisit;
};


export type MutationUpdateVisitSignInStatusArgs = {
  customerId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  method: SignInMethod;
  timezone: Scalars['String']['input'];
  visitId: Scalars['ID']['input'];
};


export type MutationUpdateVisitorArgs = {
  visitor?: InputMaybe<InputVisitor>;
};


export type MutationUpdateWidgetArgs = {
  widget: InputWidget;
};


export type MutationUpsertCustomMessageArgs = {
  customMessage: InputCustomMessage;
};


export type MutationUpsertGlobalUserRolesArgs = {
  overwriteRoles?: InputMaybe<Scalars['Boolean']['input']>;
  roles: Array<InputMaybe<UserRoleInput>>;
  userId: Scalars['ID']['input'];
};


export type MutationUpsertIotDeviceArgs = {
  iotDevice: InputIotDevice;
};


export type MutationUpsertLocalUserRolesArgs = {
  overwriteRoles?: InputMaybe<Scalars['Boolean']['input']>;
  roles: Array<InputMaybe<UserRoleInput>>;
  userId: Scalars['ID']['input'];
};


export type MutationUpsertNewUserWithUserRolesArgs = {
  email: Scalars['String']['input'];
  roles: Array<InputMaybe<UserRoleInput>>;
};


export type MutationValidateBadgePairingRequestArgs = {
  token: Scalars['String']['input'];
};


export type MutationValidateMagicLinkArgs = {
  code: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  ipAddress: Scalars['String']['input'];
};

export type NearbyDesk = {
  __typename?: 'NearbyDesk';
  _id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type NewsItem = {
  __typename?: 'NewsItem';
  _id?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<CreateData>;
  customerId?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<CreateData>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  loation?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  ttd?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
};

export type Notification = {
  __typename?: 'Notification';
  _id?: Maybe<Scalars['ID']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type NotificationEmailAddress = {
  __typename?: 'NotificationEmailAddress';
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type NotificationPrefs = {
  __typename?: 'NotificationPrefs';
  app?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationPrefsInput = {
  app?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfficeHour = {
  __typename?: 'OfficeHour';
  day?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type PagedEmployees = {
  __typename?: 'PagedEmployees';
  employees?: Maybe<Array<Maybe<Employee>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PagedRequests = {
  __typename?: 'PagedRequests';
  allCount?: Maybe<Scalars['Int']['output']>;
  archiveCount?: Maybe<Scalars['Int']['output']>;
  conflictingCount?: Maybe<Scalars['Int']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  requests?: Maybe<Array<Maybe<Request>>>;
};

export type PagedSpaces = {
  __typename?: 'PagedSpaces';
  spaces?: Maybe<Array<Maybe<Space>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PagedVisitors = {
  __typename?: 'PagedVisitors';
  total?: Maybe<Scalars['Int']['output']>;
  visitors?: Maybe<Array<Maybe<Visitor>>>;
};

export type PagedVisits = {
  __typename?: 'PagedVisits';
  expected?: Maybe<Scalars['Int']['output']>;
  signedIn?: Maybe<Scalars['Int']['output']>;
  signedOut?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  visits?: Maybe<Array<Maybe<Visit>>>;
};

export type ParkingPolicy = {
  __typename?: 'ParkingPolicy';
  allowFutureParkingBookings?: Maybe<Scalars['Boolean']['output']>;
  daysParkingCanBeBookedInFuture?: Maybe<Scalars['Int']['output']>;
  maxNumberAssignedToParking?: Maybe<Scalars['Int']['output']>;
  maxSingleDayParkingBookings?: Maybe<Scalars['Int']['output']>;
  requireParkingAssign?: Maybe<Scalars['Boolean']['output']>;
  restrictDayParkingBookingCount?: Maybe<Scalars['Boolean']['output']>;
  timeFutureParkingBookingIsEnabled?: Maybe<Scalars['String']['output']>;
};

export type PersonBookingSummary = {
  __typename?: 'PersonBookingSummary';
  _id?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isFireMarshall?: Maybe<Scalars['Boolean']['output']>;
  isFirstAider?: Maybe<Scalars['Boolean']['output']>;
  isLoopMember?: Maybe<Scalars['Boolean']['output']>;
  isVisitor?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  summaries?: Maybe<Array<Maybe<EmployeeDaySummary>>>;
};

export type Policy = CoreDoc & {
  __typename?: 'Policy';
  _id: Scalars['ID']['output'];
  cancellation?: Maybe<CancellationPolicy>;
  createdBy?: Maybe<CreateData>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  desks?: Maybe<DeskPolicy>;
  employee?: Maybe<EmployeesPolicy>;
  inOffice?: Maybe<InOfficePolicy>;
  locations?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  meetingRoom?: Maybe<MeetingRoomPolicy>;
  parking?: Maybe<ParkingPolicy>;
  privacy?: Maybe<PrivacyPolicy>;
  updatedBy?: Maybe<CreateData>;
  visitor?: Maybe<VisitorsPolicy>;
};

export enum PriceRange {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  VeryHigh = 'very_high'
}

export enum PricingModel {
  Enterprise = 'Enterprise',
  Premium = 'Premium'
}

export type PrivacyPolicy = {
  __typename?: 'PrivacyPolicy';
  daysBeforeDeskBookingAnonymisationTakesPlace?: Maybe<Scalars['Int']['output']>;
  daysBeforeVisitorAnonymisationTakesPlace?: Maybe<Scalars['Int']['output']>;
  deskBookingAnonymisationEnabled?: Maybe<Scalars['Boolean']['output']>;
  showEventTitleIfAvailable?: Maybe<Scalars['Boolean']['output']>;
  visitorAnonymisationEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PublicCustomer = {
  __typename?: 'PublicCustomer';
  _id: Scalars['ID']['output'];
  banner?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  loginMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  loginMethodsWithExtras?: Maybe<Array<Maybe<LoginMethod>>>;
  logo?: Maybe<Scalars['String']['output']>;
  migrationInProgress?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  navItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  textOnPrimaryColor?: Maybe<Scalars['String']['output']>;
};

export type PublicScreen = {
  __typename?: 'PublicScreen';
  /** Unique ID of the screen */
  _id?: Maybe<Scalars['ID']['output']>;
  /** Design and behavior of the connected display */
  configuration?: Maybe<ScreenConfiguration>;
  /** Code displayed on the screen for connection */
  connectionCode?: Maybe<Scalars['String']['output']>;
  /** Current status of the screen */
  connectionStatus?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Description provided by the user */
  description?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  /** Display name provided by the user */
  name?: Maybe<Scalars['String']['output']>;
  settingsPin?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationsResult = {
  __typename?: 'PushNotificationsResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get all the activities that have taken place against a specific document */
  activities?: Maybe<Array<Maybe<Activity>>>;
  /**
   * Get all locations that the current user can administer
   * optional roles array can be provided to only show locations for specific roles
   */
  adminLocations?: Maybe<Array<Maybe<Location>>>;
  allergens?: Maybe<Array<Maybe<Allergen>>>;
  /** Get a booking from mongoDb */
  booking?: Maybe<Booking>;
  /** For a given date and timezone get all Employees or visitors that are expected to be in the location */
  bookingOccupancyForDate?: Maybe<Array<Maybe<BookingOccupancy>>>;
  /** For a given date and timezone get all Employees or visitors that are expected to be in the location */
  bookingOccupancyForDateWithStats?: Maybe<BookingOccupancyWithStats>;
  /**
   * Get a list of active bookings occcuring on a specific date, only desk, parking and locker bookings are returned.
   * An optional spaceId can be provided to further filter the bookings.
   */
  bookings?: Maybe<Array<Maybe<Booking>>>;
  /** Checks whether a booking exists for a space within a time range */
  checkBookingExists?: Maybe<BookingExists>;
  /** Check if user has permissions for a room */
  checkUserRoomPermissions?: Maybe<UserRoomPermissions>;
  /** Get a list of news items */
  companyNews?: Maybe<Array<Maybe<NewsItem>>>;
  /**
   * Get a list of configured integrations.
   * An optional integrationID can be provided to further filter the configured integrations by specific type. e.g. O365
   */
  configuredIntegrations?: Maybe<Array<Maybe<ConfiguredIntegration>>>;
  /** Get a single conversation by id */
  conversation?: Maybe<Conversation>;
  /** Get a list of all conversations that a user has previously had with the assistant */
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  /** Get the customMessage templates for a customer, this returns a list of CustomMessages */
  customMessages?: Maybe<Array<Maybe<CustomMessage>>>;
  /** Get a single customer by its MongoDB Object ID */
  customer?: Maybe<Customer>;
  /**
   * Get a list of every user with customer access
   * This can only be achieved by super admins
   */
  customerAccesses?: Maybe<Array<Maybe<CustomerAccess>>>;
  /** Customer subscription Insight Dashboard */
  customerSubscriptionDashboardUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Get a list of customers
   * This action can only be performed by admin users
   */
  customers?: Maybe<Array<Maybe<Customer>>>;
  /**
   * Return a dashboard
   * The users current timezone should be provided. This should be a tz format like Europe/London
   */
  dashboard?: Maybe<Dashboard>;
  /** Return a list of dashboards */
  dashboards?: Maybe<Array<Maybe<Dashboard>>>;
  /**
   * Get all employees capable of booking on behalf of an employee (deprecated)
   * @deprecated delegatesForEmployee shouldn't be used, use userDelegatesForEmployee instead
   */
  delegatesForEmployee?: Maybe<DelegatesForEmployee>;
  /** Get a single employee using their customer ID and unique ID */
  employee?: Maybe<Employee>;
  /** Get an employee by badge number */
  employeeByBadgeNumber?: Maybe<Employee>;
  /** Get a single employee using their customer ID and unique pin */
  employeeByPin?: Maybe<Employee>;
  /** Get a list of roles assigned to an employee */
  employeeRoles?: Maybe<Array<Maybe<Role>>>;
  /** Get a list of employees from a single customer */
  employees?: Maybe<Array<Maybe<Employee>>>;
  /**
   * Get a list of employees and their associated booking summary for day or week
   * An optional loop and onlyToday flag can be provided.
   * This can be used to filter the returned data.
   * @deprecated Doesn't support large timezones such as America or New Zeland. Should use employeesBookingSummaryInTimezone instead.
   */
  employeesBookingSummary?: Maybe<Array<Maybe<PersonBookingSummary>>>;
  /**
   * Get a list of employees and their associated booking summary for day or week.
   * A timezone property is required
   * An optional loop and onlyToday flag can be provided.
   * This can be used to filter the returned data.
   */
  employeesBookingSummaryInTimezone?: Maybe<Array<Maybe<PersonBookingSummary>>>;
  /** Get a list of employees with particular roles for given locations */
  employeesWithRoles?: Maybe<Array<Maybe<Employee>>>;
  /** Returns a list of spaces that the current user has set as a favourite */
  favouriteSpaces?: Maybe<Array<Maybe<Space>>>;
  findEmployeeByBadgeNumber?: Maybe<BadgeNumberUser>;
  /** Find rooms in roomList user has permissions for */
  findRooms?: Maybe<RoomsList>;
  /** Get a single floor by its ID */
  floor?: Maybe<Floor>;
  /**
   * Get a single floors floorplan.
   * This requires the bucket and path of the floorplan
   */
  floorPlan?: Maybe<FloorPlanSvg>;
  /** Get a list of floors that exist on a location */
  floors?: Maybe<Array<Maybe<Floor>>>;
  /** Get all available amenities */
  getAllAvailableAmenities?: Maybe<Array<Maybe<AvailableAmenity>>>;
  /** Get available amenities by space type */
  getAvailableAmentiesBySpaceType?: Maybe<Array<Maybe<AvailableAmenity>>>;
  /** Get available amenities by space types */
  getAvailableAmentiesBySpaceTypes?: Maybe<Array<Maybe<AvailableAmenity>>>;
  /** Josh doesn't know what a comment is */
  getDailyPassById?: Maybe<DailyPass>;
  /** Gets daily passes by user id */
  getDailyPassesByUserId?: Maybe<Array<Maybe<DailyPass>>>;
  /** Get single emergencylist for a location */
  getEmergencyList?: Maybe<EmergencyList>;
  /** Get all emergencylists for a location */
  getEmergencyLists?: Maybe<Array<Maybe<EmergencyList>>>;
  getEmployeeByPin?: Maybe<User>;
  /** get daily passes for an Employee on a specific date */
  getEmployeePassesForDate?: Maybe<DailyPass>;
  /** Get a list of room bookings for a screen, only meeting room bookings are returned. */
  getInOfficePolicy?: Maybe<InOfficePolicy>;
  /**
   * Given a search term and number of employees to take/skip
   * Return a list of employees where the names or emails match the provided term
   */
  getPagedEmployeesForCustomer?: Maybe<PagedEmployees>;
  /**
   * Given a search term, locationId and number of spaces to take/skip
   * Return a list of spaces where the names or emails match the provided term
   */
  getPagedSpacesForLocation?: Maybe<PagedSpaces>;
  /** Paged visitors */
  getPagedVisitors?: Maybe<PagedVisitors>;
  /** Paged visits */
  getPagedVisits?: Maybe<PagedVisits>;
  /** Return a list of real time insights */
  getRealTimeInsights?: Maybe<Array<Maybe<RealTimeInsight>>>;
  /** Get data to allow registraition process using the customerId and locationId */
  getRegistrationDataForLocation?: Maybe<RegistrationData>;
  /** Get a list of rooms from Microsoft */
  getRoomsList?: Maybe<RoomsList>;
  /** Get a single screen without needing to be authed */
  getScreen?: Maybe<Screen>;
  getScreenByConnectionCode?: Maybe<Screen>;
  getScreenSpace?: Maybe<Space>;
  getUsersBookingsForDay?: Maybe<Array<Maybe<ScreenBooking>>>;
  /** Get registered visit by email for registration process. */
  getVisitByEmail?: Maybe<Visit>;
  /** Get registered visit by visitor Id for registration process. */
  getVisitForRegistration?: Maybe<Visit>;
  getVisitorConfiguration?: Maybe<VisitorDisplayConfiguration>;
  /** Get a list of visits for a location for a certain date */
  getVisitsOnDateByEmail?: Maybe<Array<Maybe<Visit>>>;
  /** Gets a space watcher by provider. */
  getWatcher?: Maybe<SpaceWatcher>;
  /** Get a list of all global based roles */
  globalUsersRoles?: Maybe<Array<Maybe<User>>>;
  /** Get a single group for a single customer */
  group?: Maybe<Group>;
  /**
   * Get a list of locations for a customer and group them based on their configured venue group.
   * If a location has no venue group it will be returned in the nonGroupedLocations field.
   */
  groupedLocations?: Maybe<GroupedLocations>;
  /** Get a list of groups for a single customer */
  groups?: Maybe<Array<Maybe<Group>>>;
  /** Get a list of groups for an employee */
  groupsForEmployee?: Maybe<Array<Maybe<Group>>>;
  /** Return list of available integrations */
  integrations?: Maybe<Array<Maybe<Integration>>>;
  /** Get a list of IOT Devices configured for a single space */
  iotDevices?: Maybe<Array<Maybe<IotDevice>>>;
  job?: Maybe<Job>;
  jobItem?: Maybe<JobItem>;
  jobItems?: Maybe<Array<Maybe<JobItem>>>;
  jobs?: Maybe<Array<Maybe<Job>>>;
  /** Get a single location by its MongoDB Object ID */
  location?: Maybe<Location>;
  /**
   * Get the calculated availability of a location, this returns a list of spaces
   * optional getRoomBookings can be provided. This returns rooms but without the associated room bookings
   */
  locationAvailability?: Maybe<Array<Maybe<SpaceAvailability>>>;
  /**
   * Get a list locations
   * Optional location IDS can be provided
   */
  locations?: Maybe<Array<Maybe<Location>>>;
  /** Return the MapsIndoors API key. Only used for MapsIndoors functionality */
  miAPIKey?: Maybe<Scalars['String']['output']>;
  /** Get a list of AD groups for a customer */
  microsoftAdGroups?: Maybe<Array<Maybe<MicrosoftAdGroup>>>;
  /** Get a list of AD groups for a user */
  microsoftAdGroupsForUser?: Maybe<Array<Maybe<MicrosoftAdGroup>>>;
  /**
   * Get all the Microsoft logs for a single location
   * Can filter this by space to further narrow down the results
   */
  microsoftNotificationsLogs?: Maybe<Array<Maybe<MicrosoftWatcherNotification>>>;
  /** Get a list of notifications for the current user */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /**
   * Get a list of of people counts for spaces on a specific location.
   * An optional floorId can be provided to further reduce the data returned
   */
  peopleCounts?: Maybe<Array<Maybe<SpacePeopleCount>>>;
  /** Get a list of policies by a customerID */
  policies?: Maybe<Array<Maybe<Policy>>>;
  /** Get a single policy associated to a location */
  policy?: Maybe<Policy>;
  /** Get a single screen */
  publicScreen?: Maybe<PublicScreen>;
  /**
   * Get a list of active bookings occcuring on a specific date, only desk, parking and locker bookings are returned.
   * An optional spaceId can be provided to further filter the bookings.
   */
  randomTest?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Request>;
  /** Get a list of requests at a location */
  requests?: Maybe<PagedRequests>;
  /** Get a list of open upcoming requests associated to a specific job item */
  requestsForJobItem?: Maybe<Array<Maybe<Request>>>;
  /**
   * Get the latest data from the Ricoh Environmental sensor
   * using the sensors unique local name
   */
  ricohEH?: Maybe<RicohEh>;
  /** Get a list of roles assigned to an employee */
  roles?: Maybe<Array<Maybe<Role>>>;
  /**
   * Get a list of room bookings for a specific date, only meeting room bookings are returned.
   * An optional spaceId can be provided to further filter the bookings.
   */
  roomBookings?: Maybe<Array<Maybe<Booking>>>;
  /**
   * Get a list of room bookings for a specific date, only meeting room bookings are returned.
   * An optional spaceId can be provided to further filter the bookings.
   * Also return the availability for each room.
   */
  roomBookingsAndAvailabilities?: Maybe<Array<Maybe<BookingsAndSpaceAvailabilities>>>;
  /** Upsert table view */
  saveView?: Maybe<Array<Maybe<View>>>;
  /** Get a single screen */
  screen?: Maybe<Screen>;
  /**
   * Get a list of employees and their associated booking summary for day or week.
   * A timezone property is required
   * An optional loop and onlyToday flag can be provided.
   * This can be used to filter the returned data.
   */
  screenEmployeesBookingSummaryInTimezone?: Maybe<Array<Maybe<PersonBookingSummary>>>;
  /** Get a list of employees with particular roles for given locations */
  screenEmployeesWithRoles?: Maybe<Array<Maybe<Employee>>>;
  /**
   * Get a single floors floorplan.
   * This requires the bucket and path of the floorplan
   * an optional location ID can be provided to change to a different location
   */
  screenFloorPlan?: Maybe<FloorPlanSvg>;
  /** Get a list of floors that exist on a location */
  screenFloors?: Maybe<Array<Maybe<Floor>>>;
  /** Get available amenities by space type */
  screenGetAvailableAmentiesBySpaceType?: Maybe<Array<Maybe<AvailableAmenity>>>;
  /**
   * Get the calculated availability of a location, this returns a list of spaces
   * optional getRoomBookings can be provided. This returns rooms but without the associated room bookings
   */
  screenLocationAvailability?: Maybe<Array<Maybe<SpaceAvailability>>>;
  /**
   * Get a list locations
   * Optional location IDS can be provided
   */
  screenLocations?: Maybe<Array<Maybe<Location>>>;
  /**
   * Will get the current people counts from the spaces sensor
   * This should only be used on short lists
   */
  screenPeopleCounts?: Maybe<Array<Maybe<SpacePeopleCount>>>;
  /** Get the 'in office' policy for the location that a screen is configured to */
  screenRoomBookings?: Maybe<Array<Maybe<ScreenBooking>>>;
  /**
   * Get a list of room bookings for a specific date, only meeting room bookings are returned.
   * An optional spaceId can be provided to further filter the bookings.
   */
  screenRoomBookingsFiltered?: Maybe<Array<Maybe<Booking>>>;
  /**
   * Get the calculated availability for a space
   * this return a space with a week of availability.
   * If only today is provided then the returned availability will provide a single day
   * If v1QRCode is provided, the spaceId is assumed to be a V1 QR Code string ({customerId}|{locationId}|{spaceId})
   * Any V2 QR Codes won't need the v1QRCode code flag set
   */
  screenSpaceAvailability?: Maybe<Space>;
  /** Get a list of a all screens */
  screens?: Maybe<Array<Maybe<Screen>>>;
  /**
   * Given a search term
   * return a list of employees where the user has the ability to delegate book for
   */
  searchDelegateEmployees?: Maybe<Array<Maybe<Employee>>>;
  /**
   * Given a search term
   * return a list of employees where the names or emails match the provided term
   */
  searchEmployees?: Maybe<Array<Maybe<Employee>>>;
  /** search for employees and public visitors */
  searchEmployeesAndVisitors?: Maybe<Array<Maybe<AttendeeData>>>;
  /** Search public visitors */
  searchPublicVisitors?: Maybe<Array<Maybe<Visitor>>>;
  /**
   * Search a list spaces
   * A search term must be provided. This will search the name, and email of the space
   * Optional spaceTypes can be provided which further filters the list
   * Optional flag to only return bookable spaces
   */
  searchSpaces?: Maybe<Array<Maybe<Space>>>;
  /**
   * Given a search term
   * return a list of employees where the names or emails match the provided customerId, search term and where showAsHostOnVisitorApp is true
   */
  searchVisitEmployees?: Maybe<Array<Maybe<Employee>>>;
  sendBadgeVerificationEmail?: Maybe<Scalars['Boolean']['output']>;
  sendDownloadEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Get a single space by its MongoDB Object ID */
  space?: Maybe<Space>;
  /**
   * Get the calculated availability for a space
   * this return a space with a week of availability.
   * If only today is provided then the returned availability will provide a single day
   * If v1QRCode is provided, the spaceId is assumed to be a V1 QR Code string ({customerId}|{locationId}|{spaceId})
   * Any V2 QR Codes won't need the v1QRCode code flag set
   */
  spaceAvailability?: Maybe<Space>;
  /** Get the SpaceLabels for a customer, this returns a list of SpaceLabels */
  spaceLabels?: Maybe<Array<Maybe<SpaceLabel>>>;
  /** Get a list of available space layouts for a location */
  spaceLayouts?: Maybe<Array<Maybe<SpaceLayout>>>;
  /** Get a list of single space within a customer */
  spaces?: Maybe<Array<Maybe<Space>>>;
  testServerConnection?: Maybe<Scalars['Boolean']['output']>;
  /** Get a list of available timezones */
  timezones?: Maybe<Array<Maybe<Timezone>>>;
  /** Get all employees capable of booking on behalf of an employee */
  userDelegatesForEmployee?: Maybe<DelegatesForEmployee>;
  /** Get a list of user groups from a single customer */
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
  /**
   * Get a list of groups that a single employee is a member of
   * This is limited to a single customer
   */
  userGroupsForEmployee?: Maybe<Array<Maybe<UserGroup>>>;
  /** Get a users space review for a specific space */
  userSpaceReview?: Maybe<UserSpaceReview>;
  /**
   * Get a calendar booking using the providers Id for the current user
   * The booking comes from the calendar provider
   */
  usersCalendarBooking?: Maybe<Booking>;
  /** Get a list of users for a single group */
  usersForGroup?: Maybe<Array<Maybe<Employee>>>;
  /** Get a list of users for a list of groups */
  usersForGroups?: Maybe<Array<Maybe<Employee>>>;
  /**
   * Get the current users list of bookings starting from a specified date.
   * The bookings are returned in ascending order of start time.
   * An optional take and skip parameter can be used to paginate the results.
   * An optional locationId can be provided to further filter the results
   */
  usersOrderedBookings?: Maybe<Array<Maybe<Booking>>>;
  /**
   * Get the current users calendar bookings for a specific date
   * The bookings come from the calendar provider
   */
  usersOrderedCalendarBookings?: Maybe<Array<Maybe<Booking>>>;
  /**
   * A list of bookings associated to a single user for a week.
   * The response is an ordered list of bookings with the option include Provider calendar events.
   * The response includes bookings and user statuses.
   */
  usersOrderedWeekSummary?: Maybe<Array<Maybe<DaySummary>>>;
  /** Get a list of all location based roles */
  usersRoles?: Maybe<Array<Maybe<User>>>;
  /** Gets the currently logged in user */
  viewer?: Maybe<User>;
  /** Get a visit by ID */
  visitById?: Maybe<Visit>;
  /** Get a visitor by their email */
  visitorByEmail?: Maybe<Visitor>;
  /** Get a visitor by their email for the registration process */
  visitorByEmailForRegistration?: Maybe<Visitor>;
  /** Get a visitor by their id */
  visitorById?: Maybe<Visitor>;
  /** Get a visitor by their mobile number */
  visitorByMobile?: Maybe<Visitor>;
  /** Get a visitor by their phone number for the registration process */
  visitorByMobileForRegistration?: Maybe<Visitor>;
  /** Get a list of employees who can host visitors from a single customer */
  visitorHosts?: Maybe<Array<Maybe<Employee>>>;
  /** Get a list of employees who can host visitors from a single customer without needing to be signed in */
  visitorHostsForRegistration?: Maybe<Array<Maybe<Employee>>>;
  /**
   * Get a list of visitors for a customer
   * Optional LocationID can be provided
   */
  visitors?: Maybe<Array<Maybe<Visitor>>>;
  /** Get a list of visits for a visitor */
  visitsByVisitorId?: Maybe<Array<Maybe<Visit>>>;
  /** Get a list of visits for a list of visitorIds */
  visitsByVisitorIds?: Maybe<Array<Maybe<Visit>>>;
  /** Get a list of visits for a location for a certain date */
  visitsForDate?: Maybe<Array<Maybe<Visit>>>;
  /** Get a list of visits for a location for a certain date plus following number of days, up to 7 */
  visitsForPeriod?: Maybe<Array<Maybe<Visit>>>;
  /**
   * Returns a list of spaces with collection points associated,
   * these are spaces that can be used with widgets
   */
  widgetSpaces?: Maybe<Array<Maybe<Space>>>;
  /** Return a list of widgets for a specific location and specific floor */
  widgets?: Maybe<Array<Maybe<Widget>>>;
  /** Get the zones for a location, this returns a list of Spaces */
  zones?: Maybe<Array<Maybe<Space>>>;
};


export type QueryActivitiesArgs = {
  parentId: Scalars['ID']['input'];
};


export type QueryAdminLocationsArgs = {
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryBookingArgs = {
  id: Scalars['String']['input'];
};


export type QueryBookingOccupancyForDateArgs = {
  date: Scalars['String']['input'];
  includeReleased?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  timezone: Scalars['String']['input'];
  type?: InputMaybe<BookingOccupancyViewType>;
};


export type QueryBookingOccupancyForDateWithStatsArgs = {
  date: Scalars['String']['input'];
  includeReleased?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  timezone: Scalars['String']['input'];
  type?: InputMaybe<BookingOccupancyViewType>;
};


export type QueryBookingsArgs = {
  date: Scalars['String']['input'];
  floorId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};


export type QueryCheckBookingExistsArgs = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  endTime: Scalars['String']['input'];
  floorId?: InputMaybe<Scalars['ID']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  reset?: InputMaybe<Scalars['Int']['input']>;
  seriesMasterId?: InputMaybe<Scalars['String']['input']>;
  setup?: InputMaybe<Scalars['Int']['input']>;
  spaceId: Scalars['ID']['input'];
  startTime: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type QueryCheckUserRoomPermissionsArgs = {
  locationName: Scalars['String']['input'];
  spaceEmail: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};


export type QueryConfiguredIntegrationsArgs = {
  integrationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomersArgs = {
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDashboardArgs = {
  id: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDelegatesForEmployeeArgs = {
  id: Scalars['ID']['input'];
  locationIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryEmployeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeByBadgeNumberArgs = {
  badgeNumber: Scalars['String']['input'];
};


export type QueryEmployeeByPinArgs = {
  pin: Scalars['String']['input'];
};


export type QueryEmployeeRolesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeesBookingSummaryArgs = {
  date: Scalars['String']['input'];
  includeLocationBooking?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  loop?: InputMaybe<Scalars['Boolean']['input']>;
  onlyActiveBookings?: InputMaybe<Scalars['Boolean']['input']>;
  onlyToday?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmployeesBookingSummaryInTimezoneArgs = {
  date: Scalars['String']['input'];
  includeLocationBooking?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  loop?: InputMaybe<Scalars['Boolean']['input']>;
  onlyActiveBookings?: InputMaybe<Scalars['Boolean']['input']>;
  onlyToday?: InputMaybe<Scalars['Boolean']['input']>;
  timezone: Scalars['String']['input'];
};


export type QueryEmployeesWithRolesArgs = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roleIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryFavouriteSpacesArgs = {
  spaceType?: InputMaybe<Scalars['String']['input']>;
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFindEmployeeByBadgeNumberArgs = {
  badgeNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindRoomsArgs = {
  roomList: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};


export type QueryFloorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFloorPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFloorsArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryGetAvailableAmentiesBySpaceTypeArgs = {
  spaceType: Scalars['String']['input'];
};


export type QueryGetAvailableAmentiesBySpaceTypesArgs = {
  spaceTypes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGetDailyPassByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetDailyPassesByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetEmergencyListArgs = {
  emergencyListId: Scalars['ID']['input'];
};


export type QueryGetEmergencyListsArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryGetEmployeeByPinArgs = {
  pin: Scalars['String']['input'];
};


export type QueryGetEmployeePassesForDateArgs = {
  date: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetPagedEmployeesForCustomerArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPagedSpacesForLocationArgs = {
  floorId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  take?: InputMaybe<Scalars['Int']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPagedVisitorsArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
  searchTerm: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPagedVisitsArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
  signInStatus?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRealTimeInsightsArgs = {
  locationId: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRegistrationDataForLocationArgs = {
  customerId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRoomsListArgs = {
  locationName?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
};


export type QueryGetScreenByConnectionCodeArgs = {
  connectionCode: Scalars['String']['input'];
};


export type QueryGetUsersBookingsForDayArgs = {
  date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  types?: InputMaybe<Array<InputMaybe<BookingType>>>;
  userId: Scalars['String']['input'];
};


export type QueryGetVisitByEmailArgs = {
  customerId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  email: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type QueryGetVisitForRegistrationArgs = {
  customerId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};


export type QueryGetVisitorConfigurationArgs = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryGetVisitsOnDateByEmailArgs = {
  date: Scalars['String']['input'];
  email: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
  timezone: Scalars['String']['input'];
  usersOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetWatcherArgs = {
  provider: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupsForEmployeeArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryIotDevicesArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryJobItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobItemsArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  spaceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryJobsArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationAvailabilityArgs = {
  date: Scalars['String']['input'];
  filters?: InputMaybe<AvailabilityFilters>;
  floorId?: InputMaybe<Scalars['String']['input']>;
  getRoomBookings?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  spaceType?: InputMaybe<Scalars['String']['input']>;
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  user: AvailabilityUser;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryMicrosoftAdGroupsArgs = {
  param?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMicrosoftAdGroupsForUserArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMicrosoftNotificationsLogsArgs = {
  locationId: Scalars['ID']['input'];
  spaceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPeopleCountsArgs = {
  floorId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};


export type QueryPolicyArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryRequestArgs = {
  requestId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRequestsArgs = {
  dateOfEvent?: InputMaybe<Scalars['String']['input']>;
  dateOfRequest?: InputMaybe<Scalars['String']['input']>;
  jobTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRequestsForJobItemArgs = {
  jobItemId: Scalars['ID']['input'];
};


export type QueryRicohEhArgs = {
  localName: Scalars['String']['input'];
};


export type QueryRolesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRoomBookingsArgs = {
  date: Scalars['String']['input'];
  floorId: Scalars['String']['input'];
  fromCalendarProvider?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};


export type QueryRoomBookingsAndAvailabilitiesArgs = {
  date: Scalars['String']['input'];
  filters?: InputMaybe<AvailabilityFilters>;
  floorId?: InputMaybe<Scalars['String']['input']>;
  fromCalendarProvider?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  spaceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
};


export type QuerySaveViewArgs = {
  view: InputView;
};


export type QueryScreenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScreenEmployeesBookingSummaryInTimezoneArgs = {
  date: Scalars['String']['input'];
  includeLocationBooking?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  loop?: InputMaybe<Scalars['Boolean']['input']>;
  onlyActiveBookings?: InputMaybe<Scalars['Boolean']['input']>;
  onlyToday?: InputMaybe<Scalars['Boolean']['input']>;
  timezone: Scalars['String']['input'];
};


export type QueryScreenEmployeesWithRolesArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  roleIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryScreenFloorPlanArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryScreenFloorsArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryScreenGetAvailableAmentiesBySpaceTypeArgs = {
  spaceType: Scalars['String']['input'];
};


export type QueryScreenLocationAvailabilityArgs = {
  date: Scalars['String']['input'];
  filters?: InputMaybe<AvailabilityFilters>;
  floorId?: InputMaybe<Scalars['String']['input']>;
  getRoomBookings?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  spaceType?: InputMaybe<Scalars['String']['input']>;
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  user?: InputMaybe<AvailabilityUser>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScreenLocationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryScreenPeopleCountsArgs = {
  floorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScreenRoomBookingsArgs = {
  date: Scalars['String']['input'];
};


export type QueryScreenRoomBookingsFilteredArgs = {
  date: Scalars['String']['input'];
  floorId: Scalars['String']['input'];
  fromCalendarProvider?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};


export type QueryScreenSpaceAvailabilityArgs = {
  date: Scalars['String']['input'];
  onlyToday?: InputMaybe<Scalars['Boolean']['input']>;
  spaceId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  user: AvailabilityUser;
  v1QRCode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScreensArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchDelegateEmployeesArgs = {
  locationId: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
  userDelegateType?: InputMaybe<UserDelegateType>;
};


export type QuerySearchEmployeesArgs = {
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchEmployeesAndVisitorsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchPublicVisitorsArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchSpacesArgs = {
  filterBookable?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm: Scalars['String']['input'];
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySearchVisitEmployeesArgs = {
  customerId: Scalars['ID']['input'];
  searchTerm: Scalars['String']['input'];
};


export type QuerySendBadgeVerificationEmailArgs = {
  badgeNumber: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendDownloadEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySpaceArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpaceAvailabilityArgs = {
  date: Scalars['String']['input'];
  onlyToday?: InputMaybe<Scalars['Boolean']['input']>;
  spaceId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  user: AvailabilityUser;
  v1QRCode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySpaceLabelsArgs = {
  locationId: Scalars['String']['input'];
};


export type QuerySpaceLayoutsArgs = {
  locationId: Scalars['String']['input'];
};


export type QuerySpacesArgs = {
  floorId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUserDelegatesForEmployeeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locationIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryUserGroupsForEmployeeArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserSpaceReviewArgs = {
  spaceId: Scalars['ID']['input'];
};


export type QueryUsersCalendarBookingArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersForGroupArgs = {
  groupId: Scalars['ID']['input'];
};


export type QueryUsersForGroupsArgs = {
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryUsersOrderedBookingsArgs = {
  date: Scalars['String']['input'];
  includeLocationBooking?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  onlyWeek?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersOrderedCalendarBookingsArgs = {
  date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type QueryUsersOrderedWeekSummaryArgs = {
  date: Scalars['String']['input'];
  includeCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocationBooking?: InputMaybe<Scalars['Boolean']['input']>;
  includeReleased?: InputMaybe<Scalars['Boolean']['input']>;
  timezone: Scalars['String']['input'];
};


export type QueryUsersRolesArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryVisitByIdArgs = {
  visitId: Scalars['ID']['input'];
};


export type QueryVisitorByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryVisitorByEmailForRegistrationArgs = {
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  key: Scalars['String']['input'];
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisitorByIdArgs = {
  visitorId: Scalars['ID']['input'];
};


export type QueryVisitorByMobileArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  mobile: Scalars['String']['input'];
};


export type QueryVisitorByMobileForRegistrationArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisitorHostsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisitorHostsForRegistrationArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisitorsArgs = {
  hidePrivateVisitors?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVisitsByVisitorIdArgs = {
  visitorId: Scalars['ID']['input'];
};


export type QueryVisitsByVisitorIdsArgs = {
  visitorIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryVisitsForDateArgs = {
  date: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
  timezone: Scalars['String']['input'];
  usersOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVisitsForPeriodArgs = {
  date: Scalars['String']['input'];
  futureDays?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
  timezone: Scalars['String']['input'];
};


export type QueryWidgetSpacesArgs = {
  locationId: Scalars['ID']['input'];
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryWidgetsArgs = {
  floorId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};


export type QueryZonesArgs = {
  locationId: Scalars['String']['input'];
};

export enum Request_Priority {
  High = 'high',
  Highest = 'highest',
  Low = 'low',
  Lowest = 'lowest',
  Normal = 'normal'
}

export enum Request_Status {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Complete = 'complete',
  Rejected = 'rejected',
  Requested = 'requested'
}

export type Rating = {
  __typename?: 'Rating';
  count?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type RealTimeInsight = {
  __typename?: 'RealTimeInsight';
  _id?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  measurement?: Maybe<Scalars['String']['output']>;
  measures?: Maybe<Array<Maybe<Measure>>>;
  space?: Maybe<Space>;
  spaceId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<InsightType>;
};

export type Recurrence = {
  __typename?: 'Recurrence';
  pattern?: Maybe<RecurrencePattern>;
  range?: Maybe<RecurrenceRange>;
};

export type RecurrencePattern = {
  __typename?: 'RecurrencePattern';
  type?: Maybe<Scalars['String']['output']>;
};

export type RecurrenceRange = {
  __typename?: 'RecurrenceRange';
  numberOfOccurrences?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RegistrationData = {
  __typename?: 'RegistrationData';
  customer?: Maybe<Customer>;
  location?: Maybe<Location>;
  policy?: Maybe<Policy>;
  visits?: Maybe<Array<Maybe<Visit>>>;
};

/**
 * A request is a container for 1 or more Jobs.
 * When requesting Job items a request will be created.
 * A request can be linked to a single booking or live at a location level.
 */
export type Request = {
  __typename?: 'Request';
  _id?: Maybe<Scalars['ID']['output']>;
  /** The booking assosiated with the requested jobs */
  booking?: Maybe<Booking>;
  /** When the request was accepted */
  completedDate?: Maybe<Scalars['Date']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  /** When the jobs within the request are due */
  dueDate?: Maybe<Scalars['Date']['output']>;
  /** Tags that are automatically be created */
  jobTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Jobs grouped by job category */
  jobs?: Maybe<Array<Maybe<Job>>>;
  /** Labels can be provided for search reasons */
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The layout setup time of layout requests */
  layoutSetupTime?: Maybe<Scalars['Date']['output']>;
  /** Location the rquest is for */
  location?: Maybe<Location>;
  /** In some instances this will be auto created if not provided */
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Request_Priority>;
  /** Auto number provided when created */
  requestNumber?: Maybe<Scalars['Int']['output']>;
  /** Employee making the request */
  requestedBy?: Maybe<Employee>;
  /** Employee making the request */
  requestedByDetails?: Maybe<RequestedByDetails>;
  /** WHen the request was submitted */
  requestedDate?: Maybe<Scalars['Date']['output']>;
  /** The space the request was targeted */
  space?: Maybe<Space>;
  /** Current status of the request */
  status?: Maybe<Request_Status>;
  /** Total unique catergoy jobs requested */
  totalJobs?: Maybe<Scalars['Int']['output']>;
};

export enum RequestViewType {
  All = 'all',
  Archive = 'archive',
  Conflicting = 'conflicting',
  Processed = 'processed'
}

export type RequestedByDetails = {
  __typename?: 'RequestedByDetails';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * A Requested Job Item is a snapshot of the Job Item at the point of request.
 * Addtional information is included based on user input at the time of submission
 */
export type RequestedJobItem = {
  __typename?: 'RequestedJobItem';
  _id?: Maybe<Scalars['ID']['output']>;
  allergens?: Maybe<Array<Maybe<Allergen>>>;
  assetId?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  cutOffMinutes?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  jobCategory?: Maybe<Scalars['String']['output']>;
  jobItemType?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  layout?: Maybe<SpaceLayout>;
  layoutId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resetMinutes?: Maybe<Scalars['Int']['output']>;
  setupMinutes?: Maybe<Scalars['Int']['output']>;
  userValue?: Maybe<Scalars['String']['output']>;
};

export type RequiredSpace = {
  __typename?: 'RequiredSpace';
  _id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ResponseType {
  Assistant = 'assistant',
  User = 'user'
}

export type Resposne = {
  __typename?: 'Resposne';
  role?: Maybe<Scalars['String']['output']>;
};

export type RicohEh = {
  __typename?: 'RicohEh';
  _id: Scalars['ID']['output'];
  humidity?: Maybe<Scalars['Int']['output']>;
  light?: Maybe<Scalars['Int']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  pressure?: Maybe<Scalars['Int']['output']>;
  temperature?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Role = {
  __typename?: 'Role';
  _id: Scalars['ID']['output'];
  customerId: Scalars['ID']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  roleId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

/** A room retrieved from Microsoft */
export type Room = {
  __typename?: 'Room';
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RoomDisplayConfiguration = ScreenConnection & {
  __typename?: 'RoomDisplayConfiguration';
  _id?: Maybe<Scalars['ID']['output']>;
  backgroundColour?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  backgroundType?: Maybe<Scalars['String']['output']>;
  bookingMethod?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
  inactiveChance?: Maybe<Scalars['String']['output']>;
  interactive?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<RoomPolicy>;
  space?: Maybe<Space>;
  spaceId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Connection_Type>;
};

export type RoomPolicy = {
  __typename?: 'RoomPolicy';
  allowCancelFromPanel?: Maybe<Scalars['Boolean']['output']>;
  allowEarlyCheckOutFromPanel?: Maybe<Scalars['Boolean']['output']>;
  autoCancelMeetings?: Maybe<Scalars['Boolean']['output']>;
  autoCancelTime?: Maybe<Scalars['Int']['output']>;
  maxRecurringInstances?: Maybe<Scalars['Int']['output']>;
  minutesAfterCheckIn?: Maybe<Scalars['Int']['output']>;
  minutesBeforeCheckIn?: Maybe<Scalars['Int']['output']>;
  minutesUntilCancel?: Maybe<Scalars['Int']['output']>;
  requireCheckIn?: Maybe<Scalars['Boolean']['output']>;
};

export type RoomStatus = {
  __typename?: 'RoomStatus';
  status?: Maybe<SpaceStatus>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

/** A list of rooms retrieved from Microsoft */
export type RoomsList = {
  __typename?: 'RoomsList';
  rooms?: Maybe<Array<Maybe<Room>>>;
};

export type Screen = {
  __typename?: 'Screen';
  /** Unique ID of the screen */
  _id?: Maybe<Scalars['ID']['output']>;
  /** Design and behavior of the connected display */
  configuration?: Maybe<ScreenConfiguration>;
  /** Code displayed on the screen for connection */
  connectionCode?: Maybe<Scalars['String']['output']>;
  /** Current status of the screen */
  connectionStatus?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<ScreensCreateData>;
  /** Customer the screen is conencted to */
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Description provided by the user */
  description?: Maybe<Scalars['String']['output']>;
  /** Location that the screen is connected within */
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  /** Display name provided by the user */
  name?: Maybe<Scalars['String']['output']>;
  /** The type of screen */
  type?: Maybe<Connection_Type>;
  updatedBy?: Maybe<ScreensCreateData>;
};

export type ScreenBookedByData = {
  __typename?: 'ScreenBookedByData';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ScreenBooking = {
  __typename?: 'ScreenBooking';
  _id?: Maybe<Scalars['ID']['output']>;
  bookedBy?: Maybe<ScreenBookedByData>;
  bookingType?: Maybe<BookingType>;
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  checkedIn?: Maybe<Scalars['Boolean']['output']>;
  checkedOut?: Maybe<Scalars['Boolean']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  databaseId?: Maybe<Scalars['ID']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  iCalUId?: Maybe<Scalars['String']['output']>;
  isPrePostBooking?: Maybe<Scalars['Boolean']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  requiresApproval?: Maybe<Scalars['Boolean']['output']>;
  /** resolvefield to return zone/floor/location names to panel frontend */
  screenBookingData?: Maybe<ScreenBookingData>;
  spaceId?: Maybe<Scalars['ID']['output']>;
  startTime?: Maybe<Scalars['Date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type ScreenBookingData = {
  __typename?: 'ScreenBookingData';
  floorName?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  spaceName?: Maybe<Scalars['String']['output']>;
  zoneName?: Maybe<Scalars['String']['output']>;
};

export type ScreenConfiguration = DefaultDisplayConfiguration | RoomDisplayConfiguration | VisitorDisplayConfiguration | WayfindingDisplayConfiguration;

export type ScreenConnection = {
  _id?: Maybe<Scalars['ID']['output']>;
  backgroundColour?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  interactive?: Maybe<Scalars['Boolean']['output']>;
};

export type ScreenInput = {
  _id: Scalars['ID']['input'];
  customerId: Scalars['String']['input'];
};

export type ScreenMessageTokenResult = {
  __typename?: 'ScreenMessageTokenResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type ScreenPushNotificationDataInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ScreensCreateData = {
  __typename?: 'ScreensCreateData';
  _id: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export type Security = {
  __typename?: 'Security';
  analyticsAnonymised?: Maybe<Scalars['Boolean']['output']>;
  calendarTokenType?: Maybe<Scalars['String']['output']>;
  disableIntercomChat?: Maybe<Scalars['Boolean']['output']>;
  disableMobileCalendar?: Maybe<Scalars['Boolean']['output']>;
  disableWebCalendar?: Maybe<Scalars['Boolean']['output']>;
  hideMeetingTitlesForNonAdmins?: Maybe<Scalars['Boolean']['output']>;
  hideVisitorsOnHomepageWeb?: Maybe<Scalars['Boolean']['output']>;
  privateVisitors?: Maybe<Scalars['Boolean']['output']>;
};

export type SecurityInput = {
  analyticsAnonymised?: InputMaybe<Scalars['Boolean']['input']>;
  calendarTokenType?: InputMaybe<Scalars['String']['input']>;
  disableIntercomChat?: InputMaybe<Scalars['Boolean']['input']>;
  disableMobileCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  disableWebCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  hideMeetingTitlesForNonAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  hideVisitorsOnHomepageWeb?: InputMaybe<Scalars['Boolean']['input']>;
  privateVisitors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SelectedAmenity = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum SignInMethod {
  Admin = 'admin',
  QrCode = 'qrCode',
  Registration = 'registration',
  VisitorPanel = 'visitorPanel'
}

export enum SignInStatus {
  Expected = 'expected',
  SignedIn = 'signedIn',
  SignedOut = 'signedOut'
}

export type Space = CoreDoc & {
  __typename?: 'Space';
  _id: Scalars['ID']['output'];
  addedToOutlook?: Maybe<Scalars['Boolean']['output']>;
  amenities?: Maybe<Array<Maybe<Amenity>>>;
  approvalIndividuals?: Maybe<Array<Maybe<SpaceAssignedUser>>>;
  approvalsRequired?: Maybe<Scalars['Boolean']['output']>;
  assignedGroups?: Maybe<Array<Maybe<SpaceAssignedGroup>>>;
  assignedJobItems?: Maybe<Array<Maybe<JobItem>>>;
  assignedLayouts?: Maybe<Array<Maybe<AssignedLayout>>>;
  assignedUsers?: Maybe<Array<Maybe<SpaceAssignedUser>>>;
  /** Get the calculated the current day availability of a space */
  availability?: Maybe<SpaceAvailability>;
  bookable?: Maybe<Scalars['Boolean']['output']>;
  bookingJobItem?: Maybe<JobItem>;
  bookingSlots?: Maybe<BookingSlotTemplate>;
  bookingType?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<CreateData>;
  customerId: Scalars['ID']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<CreateData>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  endorsementEnabled?: Maybe<Scalars['Boolean']['output']>;
  environment?: Maybe<SpaceEnvironment>;
  floor?: Maybe<Floor>;
  floorId?: Maybe<Scalars['String']['output']>;
  floorPlanId?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** A resolver to decide whether theres services on a space */
  hasServices?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  layouts?: Maybe<Array<Maybe<JobItem>>>;
  limitBookingsToCapacity?: Maybe<Scalars['Boolean']['output']>;
  lngLat?: Maybe<SpaceLngLat>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  mapboxId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nearbyDesks?: Maybe<Array<Maybe<NearbyDesk>>>;
  outlookId?: Maybe<Scalars['String']['output']>;
  priceRange?: Maybe<PriceRange>;
  provider?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Rating>;
  requiredSpaces?: Maybe<Array<Maybe<RequiredSpace>>>;
  spaceType?: Maybe<Scalars['String']['output']>;
  spacesInZone?: Maybe<Array<Maybe<Space>>>;
  tenant?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
  useOccupancyAsAvailability?: Maybe<Scalars['Boolean']['output']>;
  /** Get the calculated the week availability of a space */
  weekAvailability?: Maybe<Array<Maybe<SpaceAvailability>>>;
  /** Get the zone a space is in */
  zone?: Maybe<Space>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export enum SpaceAmenities {
  AccessibilitySeat = 'accessibilitySeat',
  Accessible = 'accessible',
  Bench = 'bench',
  Booth = 'booth',
  CombinationLock = 'combinationLock',
  ConferenceCall = 'conferenceCall',
  ConferencePhone = 'conferencePhone',
  DataCable = 'dataCable',
  DeskPower = 'deskPower',
  DesktopComputer = 'desktopComputer',
  DisabledSpace = 'disabledSpace',
  Display = 'display',
  DualMonitors = 'dualMonitors',
  ElectricSpace = 'electricSpace',
  FixedPc = 'fixedPC',
  HdmiDataCable = 'hdmiDataCable',
  Heated = 'heated',
  HeightAdjustable = 'heightAdjustable',
  HighSpecDesktopComputer = 'highSpecDesktopComputer',
  HighTable = 'highTable',
  HybridMeetingRoom = 'hybridMeetingRoom',
  IPad = 'iPad',
  InteractiveWhiteboard = 'interactiveWhiteboard',
  KeyLock = 'keyLock',
  Keyboard = 'keyboard',
  KeyboardMouse = 'keyboardMouse',
  LaptopRiser = 'laptopRiser',
  LargeDisplayScreen = 'largeDisplayScreen',
  LargeMonitor = 'largeMonitor',
  MacCompatible = 'macCompatible',
  Monitor = 'monitor',
  Mouse = 'mouse',
  Oversized = 'oversized',
  Phone = 'phone',
  Power = 'power',
  PowerSource = 'powerSource',
  ServiceAvailable = 'serviceAvailable',
  StandingDesk = 'standingDesk',
  Type = 'type',
  VideoConferencing = 'videoConferencing',
  WheelchairAccess = 'wheelchairAccess',
  Wifi = 'wifi',
  WindowView = 'windowView'
}

export type SpaceApprovalInput = {
  approvalIndividuals?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  approvalRequired: Scalars['Boolean']['input'];
  spaceId: Scalars['ID']['input'];
};

export type SpaceAssignedGroup = {
  __typename?: 'SpaceAssignedGroup';
  allowedDays?: Maybe<Array<Maybe<AllowedDay>>>;
  assignedBy?: Maybe<AssignedBy>;
  fullGroup?: Maybe<Group>;
  groupId?: Maybe<Scalars['ID']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

export type SpaceAssignedLayout = {
  __typename?: 'SpaceAssignedLayout';
  name?: Maybe<Scalars['String']['output']>;
};

export type SpaceAssignedUser = {
  __typename?: 'SpaceAssignedUser';
  allowedDays?: Maybe<Array<Maybe<AllowedDay>>>;
  assignedBy?: Maybe<AssignedBy>;
  fullUser?: Maybe<Employee>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** An object that stores all of the information related to a space and its availability */
export type SpaceAvailability = {
  __typename?: 'SpaceAvailability';
  bookingSlots?: Maybe<Array<Maybe<BookingSlot>>>;
  bookings?: Maybe<Array<Maybe<Booking>>>;
  canBeBooked?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When scanning a desk via a QR code, this flag will let the client know whether the desk can be booked.
   * This is different to the canBeBooked flag as the desk is still available and can be booked.
   * Just not via the QR process
   */
  canBeBookedViaQrScan?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  eventAvailability?: Maybe<EventAvailability>;
  floorAtCapacity?: Maybe<Scalars['Boolean']['output']>;
  hasBooking?: Maybe<Scalars['Boolean']['output']>;
  hasNearbyBooking?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invalidDailyPass?: Maybe<Scalars['Boolean']['output']>;
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  noPermissions?: Maybe<Scalars['Boolean']['output']>;
  noZonePermissions?: Maybe<Scalars['Boolean']['output']>;
  notValidDay?: Maybe<Scalars['Boolean']['output']>;
  outOfPolicy?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Will get the current people counts from the spaces sensor
   * This should only be used on short lists
   */
  peopleCount?: Maybe<SpacePeopleCount>;
  space?: Maybe<Space>;
  /** Used with Zones to display how many desks or capacity is available within the zone */
  totalMaximumBookings?: Maybe<Scalars['Int']['output']>;
  /** Used with Zones to display how many desks or capacity is remaining within the zone */
  totalRemaningBookings?: Maybe<Scalars['Int']['output']>;
  userHasMaxBookingsForDay?: Maybe<Scalars['Boolean']['output']>;
  userHasMaxDeskBookingsForTheWeek?: Maybe<Scalars['Boolean']['output']>;
  zoneAtCapacity?: Maybe<Scalars['Boolean']['output']>;
  zoneNotBookable?: Maybe<Scalars['Boolean']['output']>;
};

export enum SpaceCategory {
  CarParking = 'car_parking',
  CoffeeShop = 'coffee_shop',
  Gym = 'gym',
  Hotel = 'hotel',
  Other = 'other',
  Park = 'park',
  Pub = 'pub',
  Restaurant = 'restaurant',
  Shop = 'shop',
  Supermarket = 'supermarket',
  TransportLinks = 'transport_links'
}

export type SpaceEnvironment = {
  __typename?: 'SpaceEnvironment';
  humidity?: Maybe<Scalars['Int']['output']>;
  light?: Maybe<Scalars['Int']['output']>;
  pressure?: Maybe<Scalars['Int']['output']>;
  temperature?: Maybe<Scalars['Int']['output']>;
};

/** An object that stores information related to meeting labels for spaces */
export type SpaceLabel = CoreDoc & {
  __typename?: 'SpaceLabel';
  _id: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<CreateData>;
  customerId: Scalars['ID']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<CreateData>;
  id?: Maybe<Scalars['ID']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
};

/** An object that stores information related to meeting layouts for spaces */
export type SpaceLayout = {
  __typename?: 'SpaceLayout';
  _id: Scalars['ID']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SpaceLayoutInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  jobItemId?: InputMaybe<Scalars['ID']['input']>;
  layoutId: Scalars['ID']['input'];
  resetMinutes?: InputMaybe<Scalars['Int']['input']>;
  setupMinutes?: InputMaybe<Scalars['Int']['input']>;
  spaceId: Scalars['ID']['input'];
};

export type SpaceLngLat = {
  __typename?: 'SpaceLngLat';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type SpacePeopleCount = {
  __typename?: 'SpacePeopleCount';
  count?: Maybe<Scalars['Int']['output']>;
  floorPlanId?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['ID']['output']>;
  spaceType?: Maybe<SpaceType>;
};

export type SpacePermissions = {
  __typename?: 'SpacePermissions';
  noPermissions?: Maybe<Scalars['Boolean']['output']>;
  noZonePermissions?: Maybe<Scalars['Boolean']['output']>;
};

export enum SpaceStatus {
  AvailableAllDay = 'availableAllDay',
  AvailableUntil = 'availableUntil',
  BusyAllDay = 'busyAllDay',
  BusyUntil = 'busyUntil',
  NotBookable = 'notBookable',
  Unavailable = 'unavailable'
}

export enum SpaceType {
  Configuration = 'configuration',
  Desk = 'desk',
  External = 'external',
  Locker = 'locker',
  Meetingroom = 'meetingroom',
  Parking = 'parking',
  Zone = 'zone'
}

export type SpaceWatcher = {
  __typename?: 'SpaceWatcher';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  expirationDateTime?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastSyncDate?: Maybe<Scalars['Date']['output']>;
  notificationUrl?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type Status = {
  __typename?: 'Status';
  _id?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionFeatureInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionInput = {
  features?: InputMaybe<Array<InputMaybe<SubscriptionFeatureInput>>>;
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummaryType {
  Booking = 'booking',
  Status = 'status'
}

export type Timezone = {
  __typename?: 'Timezone';
  _id?: Maybe<Scalars['ID']['output']>;
  tzTimezone?: Maybe<Scalars['String']['output']>;
  utc?: Maybe<Scalars['String']['output']>;
};

export type ToogethrBooking = {
  __typename?: 'ToogethrBooking';
  toogethrId?: Maybe<Scalars['String']['output']>;
};

export enum Update_Job_Status {
  Cancelled = 'cancelled',
  Complete = 'complete',
  InProgress = 'in_progress',
  ToDo = 'to_do'
}

export type UpdateBookingStatusResponse = {
  __typename?: 'UpdateBookingStatusResponse';
  id?: Maybe<Scalars['String']['output']>;
};

export type UpdateJobInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  boardOrder?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['String']['input'];
  status: Update_Job_Status;
};

export type UpdateRequestInput = {
  requestId: Scalars['String']['input'];
  status: Request_Status;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID']['output'];
  /** @deprecated Use completedOnboarding as an aggregated value */
  completedAppOnboarding?: Maybe<Scalars['Boolean']['output']>;
  completedOnboarding?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use completedOnboarding as an aggregated value */
  completedWebOnboarding?: Maybe<Scalars['Boolean']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<PublicCustomer>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  homeLocation?: Maybe<Location>;
  homepage?: Maybe<Scalars['String']['output']>;
  isInsider?: Maybe<Scalars['Boolean']['output']>;
  labs?: Maybe<Labs>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  navigation?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  uid?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Array<Maybe<View>>>;
};

/** A document that contains information for a delegate for a user */
export type UserDelegate = {
  __typename?: 'UserDelegate';
  deskBooking?: Maybe<Scalars['Boolean']['output']>;
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  parkingBooking?: Maybe<Scalars['Boolean']['output']>;
  roomBooking?: Maybe<Scalars['Boolean']['output']>;
};

export enum UserDelegateType {
  Desk = 'desk',
  Parking = 'parking',
  Room = 'room'
}

/** A document that lists all the available groups that a user is a part of. */
export type UserGroup = {
  __typename?: 'UserGroup';
  _id: Scalars['ID']['output'];
  customerId?: Maybe<Scalars['ID']['output']>;
  groups?: Maybe<Array<Maybe<AssignedGroup>>>;
  overspill?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  locationId?: Maybe<Scalars['ID']['output']>;
  roleId?: Maybe<Scalars['ID']['output']>;
};

export type UserRoleInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};

export type UserRoomPermissions = {
  __typename?: 'UserRoomPermissions';
  userHasPermissions?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSpaceReview = {
  __typename?: 'UserSpaceReview';
  _id?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  spaceId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UserStatus = {
  __typename?: 'UserStatus';
  _id: Scalars['ID']['output'];
  customerId: Scalars['ID']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  deleteMethod?: Maybe<DeleteMethod>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AvailableStatus>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  _id: Scalars['ID']['output'];
  customerId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isHybridElectric?: Maybe<Scalars['Boolean']['output']>;
  isPoolCar?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type VenueGroup = {
  __typename?: 'VenueGroup';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type VenueGroupedLocations = {
  __typename?: 'VenueGroupedLocations';
  locations?: Maybe<Array<Maybe<Location>>>;
  venueGroupId?: Maybe<Scalars['String']['output']>;
  venueGroupName?: Maybe<Scalars['String']['output']>;
};

export type View = {
  __typename?: 'View';
  columns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  page?: Maybe<Scalars['String']['output']>;
};

export type Visit = CoreDoc & {
  __typename?: 'Visit';
  _id: Scalars['ID']['output'];
  anonymisedOn?: Maybe<Scalars['Date']['output']>;
  badgeNumber?: Maybe<Scalars['String']['output']>;
  /** Gets bookings associated with the visit */
  bookings?: Maybe<Array<Maybe<Booking>>>;
  checkInLog?: Maybe<Array<Maybe<CheckIn>>>;
  checkInStatus?: Maybe<Scalars['String']['output']>;
  createMethod?: Maybe<CreateMethod>;
  createdBy?: Maybe<CreateData>;
  customerId?: Maybe<Scalars['ID']['output']>;
  /** Gets the dailyPass associated with the visit */
  dailyPass?: Maybe<DailyPass>;
  dailyPassEmailSent?: Maybe<Scalars['Boolean']['output']>;
  dailyPassEmailSentOn?: Maybe<Scalars['Date']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<CreateData>;
  expectedDate?: Maybe<Scalars['Date']['output']>;
  expectedEnd?: Maybe<Scalars['Date']['output']>;
  hasScannedPanelQR?: Maybe<Scalars['Boolean']['output']>;
  isAnonymised?: Maybe<Scalars['Boolean']['output']>;
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  registrationCompleted?: Maybe<Scalars['Date']['output']>;
  signInLog?: Maybe<Array<Maybe<CheckIn>>>;
  signInStatus?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<CreateData>;
  visiting?: Maybe<Visiting>;
  /** Gets the visitor associated with the visit */
  visitor?: Maybe<Visitor>;
  visitorId?: Maybe<Scalars['ID']['output']>;
};

export type Visiting = {
  __typename?: 'Visiting';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type Visitor = {
  __typename?: 'Visitor';
  _id?: Maybe<Scalars['ID']['output']>;
  carRegistration?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<CreateData>;
  customerId?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<CreateData>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  inAddressBook?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  pinGeneratedBy?: Maybe<CreateData>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedBy?: Maybe<CreateData>;
  /** Gets all the visits associated with the visitor */
  visits?: Maybe<Array<Maybe<Visit>>>;
};

export type VisitorConfig = {
  __typename?: 'VisitorConfig';
  visitorFields?: Maybe<VisitorFields>;
  visitorSignInNotifyHost?: Maybe<Scalars['Boolean']['output']>;
};

export type VisitorDisplayConfiguration = ScreenConnection & {
  __typename?: 'VisitorDisplayConfiguration';
  _id?: Maybe<Scalars['ID']['output']>;
  backgroundColour?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  backgroundType?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
  interactive?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  logoURL?: Maybe<Scalars['String']['output']>;
  themeColour?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Connection_Type>;
  welcomeDescription?: Maybe<Scalars['String']['output']>;
  welcomeTitle?: Maybe<Scalars['String']['output']>;
};

export type VisitorField = {
  __typename?: 'VisitorField';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type VisitorFields = {
  __typename?: 'VisitorFields';
  carReg?: Maybe<VisitorField>;
  company?: Maybe<VisitorField>;
  jobTitle?: Maybe<VisitorField>;
  mobileNumber?: Maybe<VisitorField>;
  visiting?: Maybe<VisitorField>;
};

export type VisitorScreenConfig = {
  __typename?: 'VisitorScreenConfig';
  backgroundColour?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  themeColour?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VisitorsPolicy = {
  __typename?: 'VisitorsPolicy';
  autoCancelDeskBookingsWhenDailyPassFailed?: Maybe<Scalars['Boolean']['output']>;
  dailyPass?: Maybe<DailyPassConfig>;
  enableVisitorPicture?: Maybe<Scalars['Boolean']['output']>;
  registrationNotifyVisitor?: Maybe<Scalars['Boolean']['output']>;
  requireDailyPass?: Maybe<Scalars['Boolean']['output']>;
  requireVisitorPicture?: Maybe<Scalars['Boolean']['output']>;
  visitorFields?: Maybe<VisitorFields>;
  visitorScreenConfig?: Maybe<VisitorScreenConfig>;
  visitorSignInNotifyHost?: Maybe<Scalars['Boolean']['output']>;
};

export type WayfindingDisplayConfiguration = ScreenConnection & {
  __typename?: 'WayfindingDisplayConfiguration';
  _id?: Maybe<Scalars['ID']['output']>;
  backgroundColour?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  bookingMethod?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  displayTouch?: Maybe<Scalars['Boolean']['output']>;
  floorId?: Maybe<Scalars['String']['output']>;
  inactiveChance?: Maybe<Scalars['String']['output']>;
  interactive?: Maybe<Scalars['Boolean']['output']>;
  /** A locaiton ID can be provided to change the default location of the public screen */
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Connection_Type>;
};


export type WayfindingDisplayConfigurationLocationArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type Widget = {
  __typename?: 'Widget';
  _id?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<WidgetCategory>;
  data?: Maybe<WidgetData>;
  floorId?: Maybe<Scalars['ID']['output']>;
  lngLat?: Maybe<SpaceLngLat>;
  locationId?: Maybe<Scalars['ID']['output']>;
  showData?: Maybe<Scalars['Boolean']['output']>;
  showStatusIcon?: Maybe<Scalars['Boolean']['output']>;
  spaces?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  type?: Maybe<WidgetType>;
};

export enum WidgetCategory {
  Environmental = 'environmental',
  Occupancy = 'occupancy'
}

export type WidgetData = {
  __typename?: 'WidgetData';
  level?: Maybe<WidgetDataLevel>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum WidgetDataLevel {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum WidgetType {
  Co2 = 'co2',
  Humidity = 'humidity',
  Light = 'light',
  Sound = 'sound',
  Temperature = 'temperature'
}

export type EmployeeQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type EmployeeQuery = { __typename?: 'Query', employee?: { __typename?: 'Employee', jobTitle?: string | null } | null };

export type VisitsForPeriodQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  futureDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VisitsForPeriodQuery = { __typename?: 'Query', visitsForPeriod?: Array<{ __typename?: 'Visit', _id: string, visitorId?: string | null, locationId?: string | null, expectedDate?: any | null, expectedEnd?: any | null, isRegistered?: boolean | null, registrationCompleted?: any | null, checkInStatus?: string | null, signInStatus?: string | null, visitor?: { __typename?: 'Visitor', email?: string | null, lastName?: string | null, firstName?: string | null, carRegistration?: string | null, company?: string | null, jobTitle?: string | null, picture?: string | null } | null, visiting?: { __typename?: 'Visiting', email?: string | null, firstName?: string | null, lastName?: string | null, id?: string | null } | null, dailyPass?: { __typename?: 'DailyPass', _id?: string | null, isValid?: boolean | null, validFrom?: string | null, validTo?: string | null } | null, checkInLog?: Array<{ __typename?: 'CheckIn', timestamp?: any | null, status?: string | null } | null> | null, signInLog?: Array<{ __typename?: 'CheckIn', timestamp?: any | null, status?: string | null } | null> | null } | null> | null };

export type GetVisitorsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
  hidePrivateVisitors?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetVisitorsQuery = { __typename?: 'Query', visitors?: Array<{ __typename?: 'Visitor', _id?: string | null, carRegistration?: string | null, company?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, jobTitle?: string | null, countryCode?: string | null, mobile?: string | null, picture?: string | null, customerId?: string | null, isPrivate?: boolean | null, tags?: Array<string | null> | null } | null> | null };

export type CreateVisitorMutationVariables = Exact<{
  visitor?: InputMaybe<InputVisitor>;
}>;


export type CreateVisitorMutation = { __typename?: 'Mutation', createVisitor?: { __typename?: 'Visitor', _id?: string | null } | null };

export type CreateVisitsForSelfMutationVariables = Exact<{
  visits?: InputMaybe<Array<InputMaybe<InputVisit>> | InputMaybe<InputVisit>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateVisitsForSelfMutation = { __typename?: 'Mutation', createVisitsForSelf?: { __typename?: 'Visit', _id: string, expectedDate?: any | null, expectedEnd?: any | null, createMethod?: CreateMethod | null, visitorId?: string | null, visiting?: { __typename?: 'Visiting', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, visitor?: { __typename?: 'Visitor', _id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, mobile?: string | null, countryCode?: string | null, picture?: string | null, jobTitle?: string | null } | null } | null };

export type FloorsQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type FloorsQuery = { __typename?: 'Query', floors?: Array<{ __typename?: 'Floor', _id: string, name?: string | null, deleted?: boolean | null } | null> | null };

export type GetAvailableAmentiesBySpaceTypeQueryVariables = Exact<{
  spaceType: Scalars['String']['input'];
}>;


export type GetAvailableAmentiesBySpaceTypeQuery = { __typename?: 'Query', getAvailableAmentiesBySpaceType?: Array<{ __typename?: 'AvailableAmenity', _id: string, name?: string | null, icon?: string | null } | null> | null };

export type LocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsQuery = { __typename?: 'Query', locations?: Array<{ __typename?: 'Location', _id: string, name?: string | null, address?: { __typename?: 'LocationAddress', formattedAddress?: string | null } | null } | null> | null };

export type LocationQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', _id: string, name?: string | null, address?: { __typename?: 'LocationAddress', formattedAddress?: string | null } | null } | null };

export type LoginWithMicrosoftAddinTokenMutationVariables = Exact<{
  accessCode: Scalars['String']['input'];
}>;


export type LoginWithMicrosoftAddinTokenMutation = { __typename?: 'Mutation', loginWithMicrosoftAddinToken?: { __typename?: 'IDToken', idToken?: string | null, userHash?: string | null, kind?: string | null, refreshToken?: string | null, expiresIn?: number | null, tenant?: string | null } | null };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', customerId?: string | null, _id: string, email?: string | null, lastName?: string | null, firstName?: string | null, picture?: string | null, homeLocation?: { __typename?: 'Location', _id: string } | null } | null };

export type IssueNewTokenMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
}>;


export type IssueNewTokenMutation = { __typename?: 'Mutation', issueNewToken?: { __typename?: 'IDToken', idToken?: string | null, refreshToken?: string | null } | null };

export type RoomBookingsAndAvailabilitiesOutlookQueryVariables = Exact<{
  date: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  floorId?: InputMaybe<Scalars['String']['input']>;
  spaceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  fromCalendarProvider?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<AvailabilityFilters>;
  spaceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type RoomBookingsAndAvailabilitiesOutlookQuery = { __typename?: 'Query', roomBookingsAndAvailabilities?: Array<{ __typename?: 'BookingsAndSpaceAvailabilities', spaceId?: string | null, customerId?: string | null, spaceIsFavourite?: boolean | null, space?: { __typename?: 'Space', _id: string, customerId: string, name?: string | null, image?: string | null, email?: string | null, deleted?: boolean | null, capacity?: number | null, floorId?: string | null, bookable?: boolean | null, spaceType?: string | null, locationId?: string | null, outlookId?: string | null, addedToOutlook?: boolean | null, amenities?: Array<{ __typename?: 'Amenity', _id?: string | null, icon?: string | null, name?: string | null } | null> | null } | null, roomBookings?: Array<{ __typename?: 'Booking', databaseId?: string | null, locationId?: string | null, endTime?: any | null, startTime?: any | null, subject?: string | null, agenda?: string | null, isAllDay?: boolean | null, providerId?: string | null, iCalUId?: string | null, isPrivate?: boolean | null, requiresApproval?: boolean | null, isPrePostBooking?: boolean | null, type?: string | null, isMultiDayBooking?: boolean | null, isLinkedRoomBooking?: boolean | null, leadBookingId?: string | null, spaceId?: string | null, requestId?: string | null, bookedBy?: { __typename?: 'BookedByData', email?: string | null, bookerId?: string | null, name?: string | null } | null, bookingSpaces?: Array<{ __typename?: 'BookingSpace', id?: string | null } | null> | null, spaceLabel?: { __typename?: 'SpaceLabel', _id: string, customerId: string, name?: string | null, color?: string | null } | null, attendees?: Array<{ __typename?: 'BookingAttendee', email?: string | null, name?: string | null, status?: string | null } | null> | null, request?: { __typename?: 'Request', _id?: string | null, status?: Request_Status | null, dueDate?: any | null, totalJobs?: number | null, requestedDate?: any | null, requestedBy?: { __typename?: 'Employee', _id: string, name?: string | null } | null, space?: { __typename?: 'Space', _id: string, customerId: string, name?: string | null } | null, jobs?: Array<{ __typename?: 'Job', jobCategory?: Job_Category | null, jobItems?: Array<{ __typename?: 'RequestedJobItem', _id?: string | null, cost?: string | null, name?: string | null } | null> | null } | null> | null } | null } | null> | null, roomStatus?: { __typename?: 'RoomStatus', status?: SpaceStatus | null, timestamp?: string | null } | null, permissions?: { __typename?: 'SpacePermissions', noPermissions?: boolean | null, noZonePermissions?: boolean | null } | null } | null> | null, getAvailableAmentiesBySpaceType?: Array<{ __typename?: 'AvailableAmenity', _id: string, name?: string | null, icon?: string | null } | null> | null };

export type RoomBookingFragment = { __typename?: 'Booking', databaseId?: string | null, locationId?: string | null, endTime?: any | null, startTime?: any | null, subject?: string | null, agenda?: string | null, isAllDay?: boolean | null, providerId?: string | null, iCalUId?: string | null, isPrivate?: boolean | null, requiresApproval?: boolean | null, isPrePostBooking?: boolean | null, type?: string | null, isMultiDayBooking?: boolean | null, isLinkedRoomBooking?: boolean | null, leadBookingId?: string | null, spaceId?: string | null, requestId?: string | null, bookedBy?: { __typename?: 'BookedByData', email?: string | null, bookerId?: string | null, name?: string | null } | null, bookingSpaces?: Array<{ __typename?: 'BookingSpace', id?: string | null } | null> | null, spaceLabel?: { __typename?: 'SpaceLabel', _id: string, customerId: string, name?: string | null, color?: string | null } | null, attendees?: Array<{ __typename?: 'BookingAttendee', email?: string | null, name?: string | null, status?: string | null } | null> | null, request?: { __typename?: 'Request', _id?: string | null, status?: Request_Status | null, dueDate?: any | null, totalJobs?: number | null, requestedDate?: any | null, requestedBy?: { __typename?: 'Employee', _id: string, name?: string | null } | null, space?: { __typename?: 'Space', _id: string, customerId: string, name?: string | null } | null, jobs?: Array<{ __typename?: 'Job', jobCategory?: Job_Category | null, jobItems?: Array<{ __typename?: 'RequestedJobItem', _id?: string | null, cost?: string | null, name?: string | null } | null> | null } | null> | null } | null };

export const RoomBookingFragmentDoc = gql`
    fragment roomBooking on Booking {
  databaseId
  locationId
  bookedBy {
    email
    bookerId
    name
  }
  endTime
  startTime
  subject
  agenda
  isAllDay
  providerId
  iCalUId
  isPrivate
  requiresApproval
  isPrePostBooking
  type
  isMultiDayBooking
  isLinkedRoomBooking
  leadBookingId
  spaceId
  requestId
  providerId
  bookingSpaces {
    id
  }
  spaceLabel {
    _id
    customerId
    name
    color
  }
  attendees {
    email
    name
    status
  }
  request {
    _id
    status
    dueDate
    totalJobs
    requestedDate
    requestedBy {
      _id
      name
    }
    space {
      _id
      customerId
      name
    }
    jobs {
      jobCategory
      jobItems {
        _id
        cost
        name
      }
    }
  }
}
    `;
export const EmployeeDocument = gql`
    query Employee($employeeId: ID!) {
  employee(id: $employeeId) {
    jobTitle
  }
}
    `;

/**
 * __useEmployeeQuery__
 *
 * To run a query within a React component, call `useEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeeQuery(baseOptions: Apollo.QueryHookOptions<EmployeeQuery, EmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeQuery, EmployeeQueryVariables>(EmployeeDocument, options);
      }
export function useEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeQuery, EmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeQuery, EmployeeQueryVariables>(EmployeeDocument, options);
        }
export function useEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeQuery, EmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeQuery, EmployeeQueryVariables>(EmployeeDocument, options);
        }
export type EmployeeQueryHookResult = ReturnType<typeof useEmployeeQuery>;
export type EmployeeLazyQueryHookResult = ReturnType<typeof useEmployeeLazyQuery>;
export type EmployeeSuspenseQueryHookResult = ReturnType<typeof useEmployeeSuspenseQuery>;
export type EmployeeQueryResult = Apollo.QueryResult<EmployeeQuery, EmployeeQueryVariables>;
export const VisitsForPeriodDocument = gql`
    query VisitsForPeriod($locationId: ID!, $date: String!, $timezone: String!, $futureDays: Int) {
  visitsForPeriod(
    locationId: $locationId
    date: $date
    timezone: $timezone
    futureDays: $futureDays
  ) {
    _id
    visitorId
    locationId
    visitor {
      email
      lastName
      firstName
      carRegistration
      company
      jobTitle
      picture
    }
    visiting {
      email
      firstName
      lastName
      id
    }
    expectedDate
    expectedEnd
    isRegistered
    registrationCompleted
    dailyPass {
      _id
      isValid
      validFrom
      validTo
    }
    checkInLog {
      timestamp
      status
    }
    signInLog {
      timestamp
      status
    }
    checkInStatus
    signInStatus
  }
}
    `;

/**
 * __useVisitsForPeriodQuery__
 *
 * To run a query within a React component, call `useVisitsForPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitsForPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitsForPeriodQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      date: // value for 'date'
 *      timezone: // value for 'timezone'
 *      futureDays: // value for 'futureDays'
 *   },
 * });
 */
export function useVisitsForPeriodQuery(baseOptions: Apollo.QueryHookOptions<VisitsForPeriodQuery, VisitsForPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitsForPeriodQuery, VisitsForPeriodQueryVariables>(VisitsForPeriodDocument, options);
      }
export function useVisitsForPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitsForPeriodQuery, VisitsForPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitsForPeriodQuery, VisitsForPeriodQueryVariables>(VisitsForPeriodDocument, options);
        }
export function useVisitsForPeriodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VisitsForPeriodQuery, VisitsForPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VisitsForPeriodQuery, VisitsForPeriodQueryVariables>(VisitsForPeriodDocument, options);
        }
export type VisitsForPeriodQueryHookResult = ReturnType<typeof useVisitsForPeriodQuery>;
export type VisitsForPeriodLazyQueryHookResult = ReturnType<typeof useVisitsForPeriodLazyQuery>;
export type VisitsForPeriodSuspenseQueryHookResult = ReturnType<typeof useVisitsForPeriodSuspenseQuery>;
export type VisitsForPeriodQueryResult = Apollo.QueryResult<VisitsForPeriodQuery, VisitsForPeriodQueryVariables>;
export const GetVisitorsDocument = gql`
    query GetVisitors($locationId: ID, $hidePrivateVisitors: Boolean) {
  visitors(locationId: $locationId, hidePrivateVisitors: $hidePrivateVisitors) {
    _id
    carRegistration
    company
    firstName
    lastName
    email
    jobTitle
    countryCode
    mobile
    picture
    customerId
    isPrivate
    tags
  }
}
    `;

/**
 * __useGetVisitorsQuery__
 *
 * To run a query within a React component, call `useGetVisitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitorsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      hidePrivateVisitors: // value for 'hidePrivateVisitors'
 *   },
 * });
 */
export function useGetVisitorsQuery(baseOptions?: Apollo.QueryHookOptions<GetVisitorsQuery, GetVisitorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisitorsQuery, GetVisitorsQueryVariables>(GetVisitorsDocument, options);
      }
export function useGetVisitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisitorsQuery, GetVisitorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisitorsQuery, GetVisitorsQueryVariables>(GetVisitorsDocument, options);
        }
export function useGetVisitorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisitorsQuery, GetVisitorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisitorsQuery, GetVisitorsQueryVariables>(GetVisitorsDocument, options);
        }
export type GetVisitorsQueryHookResult = ReturnType<typeof useGetVisitorsQuery>;
export type GetVisitorsLazyQueryHookResult = ReturnType<typeof useGetVisitorsLazyQuery>;
export type GetVisitorsSuspenseQueryHookResult = ReturnType<typeof useGetVisitorsSuspenseQuery>;
export type GetVisitorsQueryResult = Apollo.QueryResult<GetVisitorsQuery, GetVisitorsQueryVariables>;
export const CreateVisitorDocument = gql`
    mutation CreateVisitor($visitor: InputVisitor) {
  createVisitor(visitor: $visitor) {
    _id
  }
}
    `;
export type CreateVisitorMutationFn = Apollo.MutationFunction<CreateVisitorMutation, CreateVisitorMutationVariables>;

/**
 * __useCreateVisitorMutation__
 *
 * To run a mutation, you first call `useCreateVisitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitorMutation, { data, loading, error }] = useCreateVisitorMutation({
 *   variables: {
 *      visitor: // value for 'visitor'
 *   },
 * });
 */
export function useCreateVisitorMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitorMutation, CreateVisitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitorMutation, CreateVisitorMutationVariables>(CreateVisitorDocument, options);
      }
export type CreateVisitorMutationHookResult = ReturnType<typeof useCreateVisitorMutation>;
export type CreateVisitorMutationResult = Apollo.MutationResult<CreateVisitorMutation>;
export type CreateVisitorMutationOptions = Apollo.BaseMutationOptions<CreateVisitorMutation, CreateVisitorMutationVariables>;
export const CreateVisitsForSelfDocument = gql`
    mutation CreateVisitsForSelf($visits: [InputVisit], $timezone: String) {
  createVisitsForSelf(visits: $visits, timezone: $timezone) {
    _id
    expectedDate
    expectedEnd
    createMethod
    visiting {
      id
      email
      firstName
      lastName
    }
    visitorId
    visitor {
      _id
      firstName
      lastName
      email
      mobile
      countryCode
      picture
      jobTitle
    }
  }
}
    `;
export type CreateVisitsForSelfMutationFn = Apollo.MutationFunction<CreateVisitsForSelfMutation, CreateVisitsForSelfMutationVariables>;

/**
 * __useCreateVisitsForSelfMutation__
 *
 * To run a mutation, you first call `useCreateVisitsForSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitsForSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitsForSelfMutation, { data, loading, error }] = useCreateVisitsForSelfMutation({
 *   variables: {
 *      visits: // value for 'visits'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useCreateVisitsForSelfMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitsForSelfMutation, CreateVisitsForSelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitsForSelfMutation, CreateVisitsForSelfMutationVariables>(CreateVisitsForSelfDocument, options);
      }
export type CreateVisitsForSelfMutationHookResult = ReturnType<typeof useCreateVisitsForSelfMutation>;
export type CreateVisitsForSelfMutationResult = Apollo.MutationResult<CreateVisitsForSelfMutation>;
export type CreateVisitsForSelfMutationOptions = Apollo.BaseMutationOptions<CreateVisitsForSelfMutation, CreateVisitsForSelfMutationVariables>;
export const FloorsDocument = gql`
    query Floors($locationId: ID!) {
  floors(locationId: $locationId) {
    _id
    name
    deleted
  }
}
    `;

/**
 * __useFloorsQuery__
 *
 * To run a query within a React component, call `useFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFloorsQuery(baseOptions: Apollo.QueryHookOptions<FloorsQuery, FloorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorsQuery, FloorsQueryVariables>(FloorsDocument, options);
      }
export function useFloorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorsQuery, FloorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorsQuery, FloorsQueryVariables>(FloorsDocument, options);
        }
export function useFloorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FloorsQuery, FloorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorsQuery, FloorsQueryVariables>(FloorsDocument, options);
        }
export type FloorsQueryHookResult = ReturnType<typeof useFloorsQuery>;
export type FloorsLazyQueryHookResult = ReturnType<typeof useFloorsLazyQuery>;
export type FloorsSuspenseQueryHookResult = ReturnType<typeof useFloorsSuspenseQuery>;
export type FloorsQueryResult = Apollo.QueryResult<FloorsQuery, FloorsQueryVariables>;
export const GetAvailableAmentiesBySpaceTypeDocument = gql`
    query GetAvailableAmentiesBySpaceType($spaceType: String!) {
  getAvailableAmentiesBySpaceType(spaceType: $spaceType) {
    _id
    name
    icon
  }
}
    `;

/**
 * __useGetAvailableAmentiesBySpaceTypeQuery__
 *
 * To run a query within a React component, call `useGetAvailableAmentiesBySpaceTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableAmentiesBySpaceTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableAmentiesBySpaceTypeQuery({
 *   variables: {
 *      spaceType: // value for 'spaceType'
 *   },
 * });
 */
export function useGetAvailableAmentiesBySpaceTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableAmentiesBySpaceTypeQuery, GetAvailableAmentiesBySpaceTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableAmentiesBySpaceTypeQuery, GetAvailableAmentiesBySpaceTypeQueryVariables>(GetAvailableAmentiesBySpaceTypeDocument, options);
      }
export function useGetAvailableAmentiesBySpaceTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableAmentiesBySpaceTypeQuery, GetAvailableAmentiesBySpaceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableAmentiesBySpaceTypeQuery, GetAvailableAmentiesBySpaceTypeQueryVariables>(GetAvailableAmentiesBySpaceTypeDocument, options);
        }
export function useGetAvailableAmentiesBySpaceTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableAmentiesBySpaceTypeQuery, GetAvailableAmentiesBySpaceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableAmentiesBySpaceTypeQuery, GetAvailableAmentiesBySpaceTypeQueryVariables>(GetAvailableAmentiesBySpaceTypeDocument, options);
        }
export type GetAvailableAmentiesBySpaceTypeQueryHookResult = ReturnType<typeof useGetAvailableAmentiesBySpaceTypeQuery>;
export type GetAvailableAmentiesBySpaceTypeLazyQueryHookResult = ReturnType<typeof useGetAvailableAmentiesBySpaceTypeLazyQuery>;
export type GetAvailableAmentiesBySpaceTypeSuspenseQueryHookResult = ReturnType<typeof useGetAvailableAmentiesBySpaceTypeSuspenseQuery>;
export type GetAvailableAmentiesBySpaceTypeQueryResult = Apollo.QueryResult<GetAvailableAmentiesBySpaceTypeQuery, GetAvailableAmentiesBySpaceTypeQueryVariables>;
export const LocationsDocument = gql`
    query Locations {
  locations {
    _id
    name
    address {
      formattedAddress
    }
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export function useLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsSuspenseQueryHookResult = ReturnType<typeof useLocationsSuspenseQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const LocationDocument = gql`
    query Location($locationId: ID!) {
  location(id: $locationId) {
    _id
    name
    address {
      formattedAddress
    }
  }
}
    `;

/**
 * __useLocationQuery__
 *
 * To run a query within a React component, call `useLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useLocationQuery(baseOptions: Apollo.QueryHookOptions<LocationQuery, LocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
      }
export function useLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export function useLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export type LocationQueryHookResult = ReturnType<typeof useLocationQuery>;
export type LocationLazyQueryHookResult = ReturnType<typeof useLocationLazyQuery>;
export type LocationSuspenseQueryHookResult = ReturnType<typeof useLocationSuspenseQuery>;
export type LocationQueryResult = Apollo.QueryResult<LocationQuery, LocationQueryVariables>;
export const LoginWithMicrosoftAddinTokenDocument = gql`
    mutation loginWithMicrosoftAddinToken($accessCode: String!) {
  loginWithMicrosoftAddinToken(accessCode: $accessCode) {
    idToken
    userHash
    kind
    refreshToken
    expiresIn
    tenant
  }
}
    `;
export type LoginWithMicrosoftAddinTokenMutationFn = Apollo.MutationFunction<LoginWithMicrosoftAddinTokenMutation, LoginWithMicrosoftAddinTokenMutationVariables>;

/**
 * __useLoginWithMicrosoftAddinTokenMutation__
 *
 * To run a mutation, you first call `useLoginWithMicrosoftAddinTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithMicrosoftAddinTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithMicrosoftAddinTokenMutation, { data, loading, error }] = useLoginWithMicrosoftAddinTokenMutation({
 *   variables: {
 *      accessCode: // value for 'accessCode'
 *   },
 * });
 */
export function useLoginWithMicrosoftAddinTokenMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithMicrosoftAddinTokenMutation, LoginWithMicrosoftAddinTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithMicrosoftAddinTokenMutation, LoginWithMicrosoftAddinTokenMutationVariables>(LoginWithMicrosoftAddinTokenDocument, options);
      }
export type LoginWithMicrosoftAddinTokenMutationHookResult = ReturnType<typeof useLoginWithMicrosoftAddinTokenMutation>;
export type LoginWithMicrosoftAddinTokenMutationResult = Apollo.MutationResult<LoginWithMicrosoftAddinTokenMutation>;
export type LoginWithMicrosoftAddinTokenMutationOptions = Apollo.BaseMutationOptions<LoginWithMicrosoftAddinTokenMutation, LoginWithMicrosoftAddinTokenMutationVariables>;
export const ViewerDocument = gql`
    query Viewer {
  viewer {
    customerId
    _id
    email
    lastName
    firstName
    picture
    homeLocation {
      _id
    }
  }
}
    `;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(baseOptions?: Apollo.QueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
      }
export function useViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export function useViewerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerSuspenseQueryHookResult = ReturnType<typeof useViewerSuspenseQuery>;
export type ViewerQueryResult = Apollo.QueryResult<ViewerQuery, ViewerQueryVariables>;
export const IssueNewTokenDocument = gql`
    mutation issueNewToken($tenantId: String!, $refreshToken: String!) {
  issueNewToken(tenantId: $tenantId, refreshToken: $refreshToken) {
    idToken
    refreshToken
  }
}
    `;
export type IssueNewTokenMutationFn = Apollo.MutationFunction<IssueNewTokenMutation, IssueNewTokenMutationVariables>;

/**
 * __useIssueNewTokenMutation__
 *
 * To run a mutation, you first call `useIssueNewTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueNewTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueNewTokenMutation, { data, loading, error }] = useIssueNewTokenMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useIssueNewTokenMutation(baseOptions?: Apollo.MutationHookOptions<IssueNewTokenMutation, IssueNewTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueNewTokenMutation, IssueNewTokenMutationVariables>(IssueNewTokenDocument, options);
      }
export type IssueNewTokenMutationHookResult = ReturnType<typeof useIssueNewTokenMutation>;
export type IssueNewTokenMutationResult = Apollo.MutationResult<IssueNewTokenMutation>;
export type IssueNewTokenMutationOptions = Apollo.BaseMutationOptions<IssueNewTokenMutation, IssueNewTokenMutationVariables>;
export const RoomBookingsAndAvailabilitiesOutlookDocument = gql`
    query RoomBookingsAndAvailabilitiesOutlook($date: String!, $locationId: String!, $timezone: String!, $floorId: String, $spaceIds: [String], $fromCalendarProvider: Boolean, $filters: AvailabilityFilters, $spaceTypes: [String]) {
  roomBookingsAndAvailabilities(
    date: $date
    locationId: $locationId
    timezone: $timezone
    floorId: $floorId
    spaceIds: $spaceIds
    fromCalendarProvider: $fromCalendarProvider
    filters: $filters
    spaceTypes: $spaceTypes
  ) {
    spaceId
    customerId
    space {
      _id
      customerId
      name
      image
      email
      deleted
      capacity
      floorId
      bookable
      amenities {
        _id
        icon
        name
      }
      spaceType
      locationId
      outlookId @client
      addedToOutlook @client
    }
    roomBookings {
      ...roomBooking
    }
    roomStatus {
      status
      timestamp
    }
    spaceIsFavourite
    permissions {
      noPermissions
      noZonePermissions
    }
  }
  getAvailableAmentiesBySpaceType(spaceType: "meetingroom") {
    _id
    name
    icon
  }
}
    ${RoomBookingFragmentDoc}`;

/**
 * __useRoomBookingsAndAvailabilitiesOutlookQuery__
 *
 * To run a query within a React component, call `useRoomBookingsAndAvailabilitiesOutlookQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomBookingsAndAvailabilitiesOutlookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomBookingsAndAvailabilitiesOutlookQuery({
 *   variables: {
 *      date: // value for 'date'
 *      locationId: // value for 'locationId'
 *      timezone: // value for 'timezone'
 *      floorId: // value for 'floorId'
 *      spaceIds: // value for 'spaceIds'
 *      fromCalendarProvider: // value for 'fromCalendarProvider'
 *      filters: // value for 'filters'
 *      spaceTypes: // value for 'spaceTypes'
 *   },
 * });
 */
export function useRoomBookingsAndAvailabilitiesOutlookQuery(baseOptions: Apollo.QueryHookOptions<RoomBookingsAndAvailabilitiesOutlookQuery, RoomBookingsAndAvailabilitiesOutlookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomBookingsAndAvailabilitiesOutlookQuery, RoomBookingsAndAvailabilitiesOutlookQueryVariables>(RoomBookingsAndAvailabilitiesOutlookDocument, options);
      }
export function useRoomBookingsAndAvailabilitiesOutlookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomBookingsAndAvailabilitiesOutlookQuery, RoomBookingsAndAvailabilitiesOutlookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomBookingsAndAvailabilitiesOutlookQuery, RoomBookingsAndAvailabilitiesOutlookQueryVariables>(RoomBookingsAndAvailabilitiesOutlookDocument, options);
        }
export function useRoomBookingsAndAvailabilitiesOutlookSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoomBookingsAndAvailabilitiesOutlookQuery, RoomBookingsAndAvailabilitiesOutlookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoomBookingsAndAvailabilitiesOutlookQuery, RoomBookingsAndAvailabilitiesOutlookQueryVariables>(RoomBookingsAndAvailabilitiesOutlookDocument, options);
        }
export type RoomBookingsAndAvailabilitiesOutlookQueryHookResult = ReturnType<typeof useRoomBookingsAndAvailabilitiesOutlookQuery>;
export type RoomBookingsAndAvailabilitiesOutlookLazyQueryHookResult = ReturnType<typeof useRoomBookingsAndAvailabilitiesOutlookLazyQuery>;
export type RoomBookingsAndAvailabilitiesOutlookSuspenseQueryHookResult = ReturnType<typeof useRoomBookingsAndAvailabilitiesOutlookSuspenseQuery>;
export type RoomBookingsAndAvailabilitiesOutlookQueryResult = Apollo.QueryResult<RoomBookingsAndAvailabilitiesOutlookQuery, RoomBookingsAndAvailabilitiesOutlookQueryVariables>;